<script  setup>
import {onBeforeUnmount, onMounted, reactive, ref, watch, nextTick, computed} from "vue";
import axios from "axios";

import SearchFlight from './Flight/SearchFlight.vue'
import ComboFlightCard from "./Flight/Components/ComboFlightCard.vue";
import ComboFlightCardEdit from "./Flight/Components/ComboFlightCardEdit.vue";
import {ElButton, ElLoading, ElMessage, ElMessageBox} from "element-plus";
import SingleFlightCardEdit from "./Flight/Components/SingleFlightCardEdit.vue";
import {ArrowDown, Rank} from "@element-plus/icons-vue";
import MannualFlight from "./Flight/MannualFlight.vue";
import MannualFlightCardEdit from "./Flight/Components/MannualFlightCardEdit.vue";
import SearchHotel from './Hotel/SearchHotel.vue'
import MannualHotelAdd from './Hotel/MannualHotelAdd.vue'
import HotelCardEdit from './Hotel/Components/HotelCardEdit.vue'
import AddDayActivity from './Activity/AddDayActivity.vue'
import ActivityCardEdit from "./Activity/ActivityCardEdit.vue";
import TransferCardEdit from "./Transfer/TransferCardEdit.vue";
import AddDayTransfer from "./Transfer/AddDayTransfer.vue";
import AddAddon from "./Addon/AddAddon.vue";
import AddonCardEdit from "./Addon/AddonCardEdit.vue";
import TravellerDetailsInfo from "../Enquiry/Components/TravellerDetailsInfo.vue";
import TravellerRequirementInfo from "../Enquiry/Components/TravellerRequirementInfo.vue";
import moment from "moment/moment";
import { QuillEditor } from '@vueup/vue-quill';
import { roundMoney, formatMoney, moneyTotal } from '../../utils/money';
import {
    calculateLandCascade,
    calculateHelicopterCascade,
    calculateSeparateCascades,
    emptyLandCascade,
    emptyHelicopterCascade,
    findAddonType,
    isLandMarkupAddon,
    isSeparateCascadeAddon,
    isBandedTypeAddon,
    resolveBandedAddonCode,
    bandedCapacityForCode,
    scaleTransportationPricing,
    transportUnits,
    DEFAULT_PRICING_RATES,
    DEFAULT_ADDON_TYPES,
    applyDiscountBeforeTax,
} from '../../utils/landPricing';


const props = defineProps({
    id:Number,
    qid:Number,
    bqid:Number,
    packages:{
        type:Number,
        default:0
    }
});

const eid=props.id;
const qid=props.qid;
const bqid=props.bqid;
const packagesFlag=props.packages || 0;

const pricingRates = ref({ ...DEFAULT_PRICING_RATES });
const addonTypes = ref([...DEFAULT_ADDON_TYPES]);

const roomtypes=ref([]);

const mealplans=ref([]);

const staytypes=ref([]);
const inclusions=ref([]);
const exclusions=ref([]);


const basicdetailsentered=ref(false);
const activeQuoteTab = ref('basic');
const draftEncryptedId = ref(null);
const autosaveStatus = ref(''); // '', saving, saved, error
const autosaveSavedAt = ref(null);
const autosaveDirty = ref(false);
const autosaveReady = ref(false);
const publishing = ref(false);
let autosaveTimer = null;
let autosaveInFlight = false;

const websitePackages = ref([]);
const websitePackagesLoading = ref(false);
const selectedPackageCodes = ref([]);
const packageOrigin = ref('');
const originCities = ref([]);
const originCityLoading = ref(false);
const flightListKey = ref(0);
const hotelListKey = ref(0);
const packageApplyLoading = ref(false);
const packageApplyError = ref('');


const ruleFormRef = ref();
const form = reactive({
    enquiry_id:eid,
    time:0,
    nights:0,
    adults: 0,
    childs: 0,
    infants: 0,
    departure_date: '',
    destinations: [],
    cities:[],
    includes:{
        hotel:false,
        landpackage:false,
        flight:false,
        visa:false,
        cruise:false,
        insurance:false
    },
    flights:[],
    hotels:[],
    addons:[],
    visadetails:'',
    insurancedetails:'',
    itineraries:[],
    banner_image:'',
    discount_type:'percent',
    discount_value:0,
    pricing:{
        landpackage:{
            adult:0,
            child:0,
            infant:0,
            total:0
        },
        flight:{
            adult:0,
            child:0,
            infant:0,
            total:0
        },
        visa:{
            adult:0,
            child:0,
            infant:0,
            total:0
        },
        cruise:{
            adult:0,
            child:0,
            infant:0,
            total:0
        },
        hotel:{
            adult:0,
            child:0,
            infant:0,
            total:0
        },
        insurance:{
            adult:0,
            child:0,
            infant:0,
            total:0
        },
        subtotal:{
            adult:0,
            child:0,
            infant:0,
            total:0
        },
        flightsubtotal:{
            adult:0,
            child:0,
            infant:0,
            total:0
        },
        profit:{
            adult:0,
            child:0,
            infant:0,
            total:0
        },
        flightprofit:{
            adult:0,
            child:0,
            infant:0,
            total:0
        },
        gst:{
            adult:0,
            child:0,
            infant:0,
            total:0
        },
        flightgst:{
            adult:0,
            child:0,
            infant:0,
            total:0
        },
        tcs:0,
        othertotal:0,
        flighttotal:0,
        total:0,
        tcsincluded:false,
        landcascade: emptyLandCascade(),
        helicoptercascade: emptyHelicopterCascade(),
        separate_cascades: [],
    },
    inclusions:[],
    exclusions:[]

});

const isRecalculatingLand = ref(false);
const hasLandPackagePricing = () =>
    !!(form.includes.landpackage || form.includes.hotel || form.includes.cruise || form.includes.visa || form.includes.insurance);

const rules = reactive({

    destinations: [
        {required: true, message: 'Required', trigger: ['blur', 'change']},
    ],
    nights: [
        {required: true, message: 'Required', trigger: ['blur', 'change']},
    ],
    departure_date: [
        {required: true, message: 'Required', trigger: ['blur', 'change']},
    ],
    adults: [
        {required: true, message: 'Required', trigger: ['blur', 'change']},
    ],
    infants: [
        {required: true, message: 'Required', trigger: ['blur', 'change']},
    ],
    childs: [
        {required: true, message: 'Required', trigger: ['blur', 'change']},
    ],
    discount_value: [
        {
            validator: (rule, value, callback) => {
                const resolved = applyDiscountBeforeTax({
                    landBeforeGst: form.pricing.landcascade?.land_before_gst || 0,
                    tcsIncluded: !!form.pricing.tcsincluded,
                    landGstPercent: pricingRates.value.land_gst,
                    tcsPercent: pricingRates.value.tcs,
                    discountType: form.discount_type,
                    discountValue: value,
                    taxesAbsorbed: Number(pricingRates.value.taxes_absorbed) === 1,
                });
                if (resolved.discount_error) {
                    callback(new Error(resolved.discount_error));
                    return;
                }
                callback();
            },
            trigger: ['blur', 'change'],
        },
    ],
});

const taxesAbsorbed = computed(() => Number(pricingRates.value.taxes_absorbed) === 1);

const chargedTaxes = computed(() => applyDiscountBeforeTax({
    landBeforeGst: form.pricing.landcascade?.land_before_gst || 0,
    tcsIncluded: !!form.pricing.tcsincluded,
    landGstPercent: pricingRates.value.land_gst,
    tcsPercent: pricingRates.value.tcs,
    flightFare: form.includes.flight ? form.pricing.flight.total : 0,
    flightService: form.includes.flight ? form.pricing.flightprofit.total : 0,
    flightServiceAdult: form.includes.flight ? form.pricing.flightprofit.adult : 0,
    flightServiceChild: form.includes.flight ? form.pricing.flightprofit.child : 0,
    flightServiceInfant: form.includes.flight ? form.pricing.flightprofit.infant : 0,
    adults: form.adults,
    childs: form.childs,
    infants: form.infants,
    flightGstPercent: pricingRates.value.flight_gst,
    separateLines: form.pricing.separate_cascades || [],
    discountType: form.discount_type,
    discountValue: form.discount_value,
    taxesAbsorbed: taxesAbsorbed.value,
}));

const quotationDiscount = computed(() => ({
    error: chargedTaxes.value.discount_error,
}));

const validateDiscountField = () => {
    if (ruleFormRef.value) {
        ruleFormRef.value.validateField('discount_value').catch(() => {});
    }
};

const validateDescription = (rule, value, callback) => {
    // Strip HTML tags and check if there's actual content
    const stripped = value ? value.replace(/<[^>]*>/g, '').trim() : '';
    if (!stripped || stripped === '') {
        callback(new Error('Required'));
    } else {
        callback();
    }
};

const alldestinations = ref([])
const destinationsTypeMap = ref({})
const destinationloading=ref(false);
const searchflightsmodel=ref(false);
const addmanualflightsmodel=ref(false);
const searchhotelmodel=ref(false);
const addmanualhotelmodel=ref(false);

/** Stash hotel/cruise stays when one service is toggled off so re-check restores them */
const stashedHotels = ref([]);
const stashedCruises = ref([]);

const isCruiseStay = (hotel) => hotel?.data?.type === 'CRUISE';

const restoreStashedHotels = () => {
    if (stashedHotels.value.length) {
        form.hotels = [...form.hotels, ...stashedHotels.value];
        stashedHotels.value = [];
    }
};

const restoreStashedCruises = () => {
    if (stashedCruises.value.length) {
        form.hotels = [...form.hotels, ...stashedCruises.value];
        stashedCruises.value = [];
    }
};

const hotelsForSubmit = () => {
    const includeHotel = !!form.includes.hotel;
    const includeCruise = !!form.includes.cruise;
    if (includeHotel && includeCruise) {
        return form.hotels;
    }
    if (includeHotel) {
        return form.hotels.filter((hotel) => !isCruiseStay(hotel));
    }
    if (includeCruise) {
        return form.hotels.filter((hotel) => isCruiseStay(hotel));
    }
    return [];
};


const gotostep2 = async (formEl) => {

    if (!formEl) return
    await formEl.validate((valid, fields) => {

        if (valid) {


            basicdetailsentered.value=true;


        }
    })
}

const getDestinations = (query) => {
    destinationloading.value = true;
    axios.get('/getdestinationlist?q='+query)
        .then(function (response) {
            destinationloading.value = false
            alldestinations.value =response.data;
            response.data.forEach(d => {
                destinationsTypeMap.value[d.name] = d.type;
            });
        });
}

const prefetchDestinationTypes = (destinationNames) => {
    if (!destinationNames || destinationNames.length === 0) return;
    const requests = destinationNames.map(name =>
        axios.get('/getdestinationlist?q=' + encodeURIComponent(name))
    );
    Promise.all(requests).then(responses => {
        responses.forEach(res => {
            res.data.forEach(d => {
                destinationsTypeMap.value[d.name] = d.type;
            });
        });
        const hasInternational = form.destinations.some(name => destinationsTypeMap.value[name] === 'International');
        form.pricing.tcsincluded = hasInternational;
        updatesubtotalcost();
    });
}

const addCity = (query) => {
    form.cities.push({
        destination:null,
        nights:1
    });
}

const removeCity = (item) => {
    const index = form.cities.indexOf(item)
    if (index !== -1) {
        form.cities.splice(index, 1)
    }
}

const dragState = reactive({
    type: null,
    from: null,
    over: null,
});

const reorderList = (list, fromIndex, toIndex) => {
    if (fromIndex === toIndex || fromIndex == null || toIndex == null) {
        return;
    }
    if (fromIndex < 0 || toIndex < 0 || fromIndex >= list.length || toIndex >= list.length) {
        return;
    }
    const [moved] = list.splice(fromIndex, 1);
    list.splice(toIndex, 0, moved);
};

const onItemDragStart = (event, type, index) => {
    dragState.type = type;
    dragState.from = index;
    dragState.over = index;
    event.dataTransfer.effectAllowed = 'move';
    event.dataTransfer.setData('text/plain', String(index));
    if (event.currentTarget && event.currentTarget.parentElement) {
        event.currentTarget.parentElement.classList.add('is-dragging');
    }
};

const onItemDragOver = (event, type, index) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
    if (dragState.type === type) {
        dragState.over = index;
    }
};

const onItemDrop = (event, type, index, list = null) => {
    event.preventDefault();
    if (dragState.type !== type) {
        return;
    }
    const target = list || (type === 'flights' ? form.flights : form.hotels);
    reorderList(target, dragState.from, index);
    dragState.type = null;
    dragState.from = null;
    dragState.over = null;
};

const onItemDragEnd = (event) => {
    if (event.currentTarget && event.currentTarget.parentElement) {
        event.currentTarget.parentElement.classList.remove('is-dragging');
    }
    dragState.type = null;
    dragState.from = null;
    dragState.over = null;
};

const collapsedDays = reactive({});

const dayRowKey = (item, index) => {
    if (!item._dayKey) {
        item._dayKey = 'day-' + String(index) + '-' + Math.random().toString(16).slice(2);
    }
    return item._dayKey;
};

const isDayCollapsed = (item) => !!(item._dayKey && collapsedDays[item._dayKey]);

const toggleDayCollapsed = (item, index) => {
    const key = dayRowKey(item, index);
    collapsedDays[key] = !collapsedDays[key];
};

const renumberItineraryDays = () => {
    form.itineraries.forEach((day, dayIndex) => {
        day.day = dayIndex + 1;
    });
};

const onDayDrop = (event, index) => {
    onItemDrop(event, 'days', index, form.itineraries);
    renumberItineraryDays();
};

const removeItineraryDay = (index) => {
    if (form.itineraries.length <= 1) {
        ElMessage({
            message: 'At least one day is required.',
            type: 'warning',
        });
        return;
    }
    ElMessageBox.confirm('Remove this day from the quotation?', 'Remove day', {
        confirmButtonText: 'Remove',
        cancelButtonText: 'Cancel',
        type: 'warning',
    }).then(() => {
        const [removed] = form.itineraries.splice(index, 1);
        if (removed && removed._dayKey) {
            delete collapsedDays[removed._dayKey];
        }
        renumberItineraryDays();
        form.nights = Math.max(0, form.itineraries.length - 1);
    }).catch(() => {});
};

const activityDrag = reactive({
    day: null,
    from: null,
    over: null,
});

const activityListKey = (activity, day, index) => {
    if (!activity._dragKey) {
        activity._dragKey = 'k-' + String(day) + '-' + index + '-' + Math.random().toString(16).slice(2);
    }
    return activity._dragKey;
};

const activityRowAtPoint = (x, y) => {
    const el = document.elementFromPoint(x, y);
    const row = el && el.closest ? el.closest('[data-activity-row]') : null;
    if (!row) {
        return null;
    }
    return {
        day: row.getAttribute('data-activity-day'),
        index: Number(row.getAttribute('data-activity-index')),
    };
};

const onActivityMouseMove = (event) => {
    if (activityDrag.day == null) {
        return;
    }
    const row = activityRowAtPoint(event.clientX, event.clientY);
    if (!row || String(row.day) !== String(activityDrag.day) || Number.isNaN(row.index)) {
        return;
    }
    activityDrag.over = row.index;
};

const stopActivityDrag = () => {
    document.removeEventListener('mousemove', onActivityMouseMove);
    document.removeEventListener('mouseup', onActivityMouseUp);
    document.body.classList.remove('quote-activity-dragging');
};

const onActivityMouseUp = () => {
    const day = activityDrag.day;
    const from = activityDrag.from;
    const over = activityDrag.over;
    const itinerary = (form.itineraries || []).find((row) => String(row.day) === String(day));
    stopActivityDrag();
    activityDrag.day = null;
    activityDrag.from = null;
    activityDrag.over = null;
    if (day == null || from == null || over == null || from === over) {
        return;
    }
    if (itinerary && Array.isArray(itinerary.activities)) {
        reorderList(itinerary.activities, from, over);
    }
};

const onActivityHandleDown = (event, day, index) => {
    if (event.button !== 0) {
        return;
    }
    event.preventDefault();
    event.stopPropagation();
    activityDrag.day = day;
    activityDrag.from = index;
    activityDrag.over = index;
    document.body.classList.add('quote-activity-dragging');
    document.addEventListener('mousemove', onActivityMouseMove);
    document.addEventListener('mouseup', onActivityMouseUp);
};

const onBeforeUnload = (event) => {
    if (autosaveDirty.value && basicdetailsentered.value && !publishing.value) {
        event.preventDefault();
        event.returnValue = '';
    }
};

onBeforeUnmount(() => {
    stopActivityDrag();
    window.removeEventListener('beforeunload', onBeforeUnload);
    if (autosaveTimer) {
        clearTimeout(autosaveTimer);
    }
});

const normalizeFlightPerPersonPricing = (flight) => {
    const adults = parseFloat(form.adults) || 0;
    const childs = parseFloat(form.childs) || 0;
    const infants = parseFloat(form.infants) || 0;
    let total = roundMoney(flight.pricing?.total);
    let adult = roundMoney(flight.pricing?.adult);
    let child = roundMoney(flight.pricing?.child);
    let infant = roundMoney(flight.pricing?.infant);

    // Legacy/external data sometimes stored full total in adult fare.
    if (
        adults > 1
        && total > 0
        && adult === total
        && child === 0
        && infant === 0
    ) {
        adult = roundMoney(total / adults);
    } else if (
        adults > 0
        && total > 0
        && adult === 0
        && child === 0
        && infant === 0
    ) {
        adult = roundMoney(total / adults);
    }

    flight.pricing.total = total;
    flight.pricing.adult = adult;
    flight.pricing.child = child;
    flight.pricing.infant = infant;

    return flight.pricing;
};

const addflight=(flight)=>{
    const adultFare = roundMoney(flight.pricedetails?.fares?.ADULT);
    const childFare = roundMoney(flight.pricedetails?.fares?.CHILD);
    const infantFare = roundMoney(flight.pricedetails?.fares?.INFANT);
    const totalFare = roundMoney(flight.pricedetails?.totalfare);
    const pricing = normalizeFlightPerPersonPricing({
        pricing: {
            total: totalFare,
            adult: adultFare,
            child: childFare,
            infant: infantFare,
        }
    });

    form.flights.push({
        "source":'api',
        "type":"combo",
        "data":flight,
        "id":"id"+(new Date()).getTime(),
        "pricing":pricing,
        "refundable":flight.pricedetails.refundable
    });

    updateflightcost();

    ElMessage({
        message: 'Flight Added Sucessfully.',
        type: 'success',
    })
}

const addflights=(flight)=>{
    const adultFare = roundMoney(flight.pricedetails?.fares?.ADULT);
    const childFare = roundMoney(flight.pricedetails?.fares?.CHILD);
    const infantFare = roundMoney(flight.pricedetails?.fares?.INFANT);
    const totalFare = roundMoney(flight.pricedetails?.totalfare);
    const pricing = normalizeFlightPerPersonPricing({
        pricing: {
            total: totalFare,
            adult: adultFare,
            child: childFare,
            infant: infantFare,
        }
    });

    form.flights.push({
        "source":'api',
        "type":"single",
        "data":flight,
        "id":"id"+(new Date()).getTime(),
        "pricing":pricing,
        "refundable":flight.pricedetails.refundable
    });

    updateflightcost();

    ElMessage({
        message: 'Flight Added Sucessfully.',
        type: 'success',
    })
}




const addflightMannual=(flight)=>{
    const pricing = normalizeFlightPerPersonPricing({
        pricing: {
            total: flight.pricing.total,
            adult: flight.pricing.adult ? flight.pricing.adult : 0,
            child: flight.pricing.child ? flight.pricing.child : 0,
            infant: flight.pricing.infant ? flight.pricing.infant : 0,
        }
    });

    form.flights.push({
        "source":'mannual',
        "id":"id"+(new Date()).getTime(),
        "data":flight.data,
        "pricing":pricing,
        "refundable":flight.refundable
    });

    updateflightcost();

    ElMessage({
        message: 'Flight Added Sucessfully.',
        type: 'success',
    })


    addmanualflightsmodel.value=false;
}



const removeflight=(flight)=>{
    const index = form.flights.indexOf(flight)
    if (index !== -1) {
        form.flights.splice(index, 1)
    }
}




const addhotel=(details,hotel,room)=>{

    let adultprice=roundMoney(room.price/form.adults);
    let totalprice=roundMoney(adultprice*form.adults);




    form.hotels.push({
        "source":'api',
        "id":"id"+(new Date()).getTime(),
        "data":{

            "name":hotel.name,
            "rating":hotel.rating,
            "type":hotel.type,
            "address":hotel.address.address,
            "city":hotel.address.city,
            "rooms":room.rooms,
            "checkIn":details.checkinDate,
            "checkOut":details.checkoutDate,
            "comments":''
        },
        "pricing":{
            "total":totalprice,
            "adult":adultprice,
            "child":0 ,
            "infant":0,
        }
    });

    ElMessage({
        message: 'Stay Added Sucessfully.',
        type: 'success',
    })

    searchhotelmodel.value=false;
}

const addhotelm=(hotel)=>{



    form.hotels.push({
        "source":'mannual',
        "id":"id"+(new Date()).getTime(),
        "data":{
            "name":hotel.name,
            "rating":hotel.rating,
            "type":hotel.type,
            "address":hotel.address,
            "city":hotel.city,
            "rooms":hotel.rooms,
            "checkIn":hotel.checkIn,
            "checkOut":hotel.checkOut,
            "comments":''
        },
        "pricing":hotel.pricing
    });

    ElMessage({
        message: 'Stay Added Sucessfully.',
        type: 'success',
    })
    addmanualhotelmodel.value=false;
}


const removehotel=(hotel)=>{
    const index = form.hotels.indexOf(hotel)
    if (index !== -1) {
        form.hotels.splice(index, 1)
    }
}


const applyingWebsitePackage = ref(false);

const nightchange=()=>{
    if (applyingWebsitePackage.value) {
        return;
    }
    if(form.includes.landpackage){
        const nights=parseInt(form.nights);
        if(nights+1>form.itineraries.length){
            for(var x=form.itineraries.length+1;x<=nights+1;x++){
                form.itineraries.push({
                    day:x,
                    description:'',
                    title:'',
                    transfers:[],
                    activities:[],
                    breakfast:false,
                    lunch:false,
                    dinner:false,
                    lunchordinner:false,
                });
            }
        }
        else if(nights+1<form.itineraries.length){
            while(nights+1<form.itineraries.length){
                form.itineraries.pop();
            }
        }
    }

}


const  addactiten=ref(null);
const addactivitymodal=ref(false);
const addactivity = (item) => {
    addactiten.value=item;
    addactivitymodal.value=true;
}




const  addtranfern=ref(null);
const addtransfermodal=ref(false);
const addtransfer = (item) => {
    addtranfern.value=item;
    addtransfermodal.value=true;
}
const removetransfer = (item,index) => {

    item.transfers.splice(index, 1)

}

watch(
    () => form.includes.landpackage,
    (value) => {
        if (value) {
            nightchange();
        }
        updatelandcost();
    },
    { deep: true }
)

watch(
    () => form.addons,
    (value) => {
        updatelandcost()
    },
    { deep: true }
)

watch(
    () => form.itineraries,
    (value) => {
        updatelandcost()
    },
    { deep: true }
)

watch(
    () => form.flights,
    (value) => {
        updateflightcost()
    },
    { deep: true }
)



watch(
    () => form.hotels,
    (value) => {
        updatestaycost()
    },
    { deep: true }
)


watch(
    () => form.includes.hotel,
    (value) => {
        if (value) {
            restoreStashedHotels();
            if (!form.includes.cruise) {
                const cruises = form.hotels.filter((hotel) => isCruiseStay(hotel));
                const hotels = form.hotels.filter((hotel) => !isCruiseStay(hotel));
                if (cruises.length) {
                    stashedCruises.value = [...stashedCruises.value, ...cruises];
                    form.hotels = hotels;
                }
            }
        } else if (form.includes.cruise) {
            const hotels = form.hotels.filter((hotel) => !isCruiseStay(hotel));
            const cruises = form.hotels.filter((hotel) => isCruiseStay(hotel));
            if (hotels.length) {
                stashedHotels.value = [...stashedHotels.value, ...hotels];
            }
            form.hotels = cruises;
        }
        // Both off: keep form.hotels intact (Stays section is hidden)
        updatestaycost();
    },
    { deep: true }
)

watch(
    () => form.includes.cruise,
    (value) => {
        if (value) {
            restoreStashedCruises();
            if (!form.includes.hotel) {
                const hotels = form.hotels.filter((hotel) => !isCruiseStay(hotel));
                const cruises = form.hotels.filter((hotel) => isCruiseStay(hotel));
                if (hotels.length) {
                    stashedHotels.value = [...stashedHotels.value, ...hotels];
                    form.hotels = cruises;
                }
            }
        } else if (form.includes.hotel) {
            const cruises = form.hotels.filter((hotel) => isCruiseStay(hotel));
            const hotels = form.hotels.filter((hotel) => !isCruiseStay(hotel));
            if (cruises.length) {
                stashedCruises.value = [...stashedCruises.value, ...cruises];
            }
            form.hotels = hotels;
        }
        // Both off: keep form.hotels intact (Stays section is hidden)
        updatestaycost();
    },
    { deep: true }
)

watch(
    () => form.includes.flight,
    () => {
        updatesubtotalcost();
    },
    { deep: true }
)

watch(
    () => form.includes.visa,
    () => {
        applyLandCascade();
    },
    { deep: true }
)

watch(
    () => form.includes.insurance,
    () => {
        applyLandCascade();
    },
    { deep: true }
)

const isBandedAddon = (addon) =>
    isBandedTypeAddon(addon, addonTypes.value);

const capacityForAddon = (addon) => {
    const code = resolveBandedAddonCode(addon, addonTypes.value);
    return bandedCapacityForCode(code, pricingRates.value);
};

/**
 * Resolve unit cost for banded addons without wiping/double-scaling.
 * Prefer stored unit_cost; else total/units; else total as price-of-one.
 */
const resolveTransportUnitCost = (pricing) => {
    const stored = pricing?.unit_cost;
    if (stored !== undefined && stored !== null && stored !== '') {
        const n = Number(stored);
        if (!Number.isNaN(n)) {
            return n;
        }
    }
    const total = Number(pricing?.total ?? 0);
    const units = Number(pricing?.units ?? 0);
    if (total > 0 && units > 0) {
        return roundMoney(total / units);
    }
    if (total > 0) {
        return total;
    }
    return null;
};

/** Scale transportation / puja / darshan addons from unit_cost; does not wipe other line items. */
const rescaleTransportationAddons = ({ updateLand = true } = {}) => {
    let changed = false;
    (form.addons || []).forEach((addon) => {
        if (!isBandedAddon(addon)) {
            return;
        }
        if (!addon.pricing) {
            addon.pricing = { total: 0, adult: 0, child: 0, infant: 0 };
        }
        const unitCost = resolveTransportUnitCost(addon.pricing);
        if (unitCost === null) {
            return;
        }
        const scaled = scaleTransportationPricing({
            unitCost,
            adults: form.adults,
            capacity: capacityForAddon(addon),
        });
        addon.pricing.unit_cost = scaled.unit_cost;
        addon.pricing.units = scaled.units;
        addon.pricing.total = scaled.total;
        addon.pricing.adult = scaled.adult;
        addon.pricing.child = 0;
        addon.pricing.infant = 0;
        changed = true;
    });
    if (changed && updateLand) {
        updatelandcost();
    }
    return changed;
};

/**
 * Keep per-person rates; refresh totals for new adult/child/infant counts.
 * Skips banded addons (handled by rescaleTransportationAddons).
 */
const recalcLineItemTotals = () => {
    const adults = form.adults;
    const childs = form.childs;
    const infants = form.infants;

    const recalcPricing = (pricing) => {
        if (!pricing) {
            return;
        }
        pricing.total = moneyTotal(
            adults,
            pricing.adult,
            childs,
            pricing.child,
            infants,
            pricing.infant
        );
    };

    (form.flights || []).forEach((item) => recalcPricing(item.pricing));
    (form.hotels || []).forEach((item) => recalcPricing(item.pricing));

    (form.addons || []).forEach((addon) => {
        if (isBandedAddon(addon)) {
            return;
        }
        recalcPricing(addon.pricing);
    });

    (form.itineraries || []).forEach((day) => {
        (day.transfers || []).forEach((t) => recalcPricing(t.pricing));
        (day.activities || []).forEach((a) => recalcPricing(a.pricing));
    });
};

/** Called when Adults / Child / Infants change in Basic Details (does NOT wipe prices). */
const onTravellerCountChange = () => {
    recalcLineItemTotals();
    rescaleTransportationAddons({ updateLand: false });
    updateflightcost();
    updatestaycost();
    updatelandcost();
    updatevisacost();
    updateinsurancecost();
    applyLandCascade();
};

watch(
    () => [
        pricingRates.value.transportation_adults_per_unit,
        pricingRates.value.puja_adults_per_unit,
        pricingRates.value.darshan_adults_per_unit,
    ],
    () => {
        rescaleTransportationAddons({ updateLand: false });
        updatelandcost();
        applyLandCascade();
    }
);

watch(
    () => form.pricing.visa.adult,
    (value) => {
        updatevisacost();
    }
)

watch(
    () => form.pricing.visa.infant,
    (value) => {
        updatevisacost();
    }
)

watch(
    () => form.pricing.visa.child,
    (value) => {
        updatevisacost();
    }
)

watch(
    () => form.pricing.insurance.adult,
    (value) => {
        updateinsurancecost();
    }
)

watch(
    () => form.pricing.insurance.infant,
    (value) => {
        updateinsurancecost();
    }
)

watch(
    () => form.pricing.insurance.child,
    (value) => {
        updateinsurancecost();
    }
)
watch(
    () => form.pricing,
    (value) => {
        if (isRecalculatingLand.value) {
            return;
        }
        updatesubtotalcost()
    },
    { deep: true }
)

watch(
    () => form.pricing.flightprofit,
    (value) => {
        updateflightprofitcost();
    },
    { deep: true }
)

watch(
    () => form.destinations,
    (value) => {
        const hasInternational = value.some(name => destinationsTypeMap.value[name] === 'International');
        form.pricing.tcsincluded = hasInternational;
        applyLandCascade();
    },
    { deep: true }
)

watch(
    () => form.pricing.tcsincluded,
    () => {
        applyLandCascade();
    }
)

/**
 * Base land lines (ex-hotel, ex-transport, ex-helicopter): activities + itinerary transfers + other addons.
 * Transportation addons are in landcascade; Helicopter has its own cascade.
 */
const updatelandcost = () => {
    let total=0;
    let adult=0;
    let infant=0;
    let child=0;

    form.itineraries.forEach((itenary) => {
        itenary.activities.forEach((activity) => {
            total+=roundMoney(activity.pricing.total);
            adult+=roundMoney(activity.pricing.adult);
            infant+=roundMoney(activity.pricing.infant);
            child+=roundMoney(activity.pricing.child);
        });

        itenary.transfers.forEach((transfer) => {
            total+=roundMoney(transfer.pricing.total);
            adult+=roundMoney(transfer.pricing.adult);
            infant+=roundMoney(transfer.pricing.infant);
            child+=roundMoney(transfer.pricing.child);
        });
    });

    form.addons.forEach((addon) => {
        const matched = findAddonType(addon, addonTypes.value);
        if (matched) {
            return;
        }
        total+=roundMoney(addon.pricing.total);
        adult+=roundMoney(addon.pricing.adult);
        infant+=roundMoney(addon.pricing.infant);
        child+=roundMoney(addon.pricing.child);
    });

    form.pricing.landpackage.total=roundMoney(total);
    form.pricing.landpackage.adult=roundMoney(adult);
    form.pricing.landpackage.infant=roundMoney(infant);
    form.pricing.landpackage.child=roundMoney(child);

    applyLandCascade();
}

const updatestaycost = () => {
    let total=0;
    let adult=0;
    let infant=0;
    let child=0;
    let cruisetotal=0;
    let cruiseadult=0;
    let cruiseinfant=0;
    let cruisechild=0;

    form.hotels.forEach((hotel) => {
        if (hotel.packageMissing) {
            return;
        }
        if(hotel.data.type=="CRUISE"){
            cruisetotal+=roundMoney(hotel.pricing.total);
            cruiseadult+=roundMoney(hotel.pricing.adult);
            cruiseinfant+=roundMoney(hotel.pricing.infant);
            cruisechild+=roundMoney(hotel.pricing.child);
        }
        else{
            total+=roundMoney(hotel.pricing.total);
            adult+=roundMoney(hotel.pricing.adult);
            infant+=roundMoney(hotel.pricing.infant);
            child+=roundMoney(hotel.pricing.child);
        }
    });

    form.pricing.hotel.total=roundMoney(total);
    form.pricing.hotel.adult=roundMoney(adult);
    form.pricing.hotel.infant=roundMoney(infant);
    form.pricing.hotel.child=roundMoney(child);
    form.pricing.cruise.total=roundMoney(cruisetotal);
    form.pricing.cruise.infant=roundMoney(cruiseinfant);
    form.pricing.cruise.child=roundMoney(cruisechild);
    form.pricing.cruise.adult=roundMoney(cruiseadult);
    applyLandCascade();
}

const FLIGHT_PROFIT_PERCENT = () => Number(pricingRates.value.flight_service_charge ?? DEFAULT_PRICING_RATES.flight_service_charge);
const FLIGHT_GST_PERCENT = () => Number(pricingRates.value.flight_gst ?? DEFAULT_PRICING_RATES.flight_gst);

const prefillFlightProfitFromCost = () => {
    const profitPct = FLIGHT_PROFIT_PERCENT();
    form.pricing.flightprofit.adult = roundMoney((roundMoney(form.pricing.flight.adult) / 100) * profitPct);
    form.pricing.flightprofit.child = roundMoney((roundMoney(form.pricing.flight.child) / 100) * profitPct);
    form.pricing.flightprofit.infant = roundMoney((roundMoney(form.pricing.flight.infant) / 100) * profitPct);

    form.pricing.flightprofit.total = roundMoney(
        (parseFloat(form.adults || 0) * roundMoney(form.pricing.flightprofit.adult)) +
        (parseFloat(form.childs || 0) * roundMoney(form.pricing.flightprofit.child)) +
        (parseFloat(form.infants || 0) * roundMoney(form.pricing.flightprofit.infant))
    );
};

const updateflightcost = () => {
    let total=0;
    let adult=0;
    let infant=0;
    let child=0;

    form.flights.forEach((flight) => {
        if (flight.packageMissing) {
            return;
        }
        const pricing = normalizeFlightPerPersonPricing(flight);
        total+=roundMoney(pricing.total);
        adult+=roundMoney(pricing.adult);
        infant+=roundMoney(pricing.infant);
        child+=roundMoney(pricing.child);
    });

    form.pricing.flight.total=roundMoney(total);
    form.pricing.flight.adult=roundMoney(adult);
    form.pricing.flight.infant=roundMoney(infant);
    form.pricing.flight.child=roundMoney(child);

    // Always auto-apply flight service cost + GST from settings
    prefillFlightProfitFromCost();
    updateflightgstcost();
    updatesubtotalcost();
}


const updatevisacost = () => {
    let total=0;

    total+=(form.adults)*roundMoney(form.pricing.visa.adult);
    total+=(form.childs)*roundMoney(form.pricing.visa.child);
    total+=(form.infants)*roundMoney(form.pricing.visa.infant);

    form.pricing.visa.total=roundMoney(total);

    applyLandCascade();
}

const updateinsurancecost = () => {
    let total=0;

    total+=(form.adults)*roundMoney(form.pricing.insurance.adult);
    total+=(form.childs)*roundMoney(form.pricing.insurance.child);
    total+=(form.infants)*roundMoney(form.pricing.insurance.infant);

    form.pricing.insurance.total=roundMoney(total);

    applyLandCascade();
}

const applyLandCascade = () => {
    if (!hasLandPackagePricing() && !form.pricing.tcsincluded) {
        // Still clear cascade when nothing land-related is selected
    }

    isRecalculatingLand.value = true;

    const landAddons = form.includes.landpackage ? form.addons : [];
    const landItineraries = form.includes.landpackage ? form.itineraries : [];

    const cascade = calculateLandCascade({
        hotelCost: form.includes.hotel ? form.pricing.hotel.total : 0,
        cruiseCost: form.includes.cruise ? form.pricing.cruise.total : 0,
        visaCost: form.includes.visa ? form.pricing.visa.total : 0,
        insuranceCost: form.includes.insurance ? form.pricing.insurance.total : 0,
        addons: landAddons,
        itineraries: landItineraries,
        tcsincluded: form.pricing.tcsincluded,
    }, pricingRates.value, addonTypes.value);

    form.pricing.landcascade = cascade;

    form.pricing.separate_cascades = calculateSeparateCascades({
        addons: landAddons,
    }, addonTypes.value);

    form.pricing.helicoptercascade = calculateHelicopterCascade({
        addons: landAddons,
    }, pricingRates.value, addonTypes.value);

    // Compatibility fields used by save / convert / PDFs
    form.pricing.profit.adult = 0;
    form.pricing.profit.child = 0;
    form.pricing.profit.infant = 0;
    form.pricing.profit.total = cascade.land_profit;

    form.pricing.gst.adult = 0;
    form.pricing.gst.child = 0;
    form.pricing.gst.infant = 0;
    form.pricing.gst.total = cascade.land_gst;

    form.pricing.subtotal.adult = 0;
    form.pricing.subtotal.child = 0;
    form.pricing.subtotal.infant = 0;
    form.pricing.subtotal.total = cascade.land_total;

    form.pricing.tcs = cascade.tcs;
    form.pricing.othertotal = cascade.package_total;

    isRecalculatingLand.value = false;
    updatesubtotalcost();
}

const updatesubtotalcost = () => {
    // Land package total comes from land cascade; only roll up flight + helicopter + grand total here
    if (!isRecalculatingLand.value && hasLandPackagePricing()) {
        // Keep othertotal in sync if cascade already present
        if (form.pricing.landcascade && form.pricing.landcascade.package_total !== undefined) {
            form.pricing.othertotal = roundMoney(form.pricing.landcascade.package_total);
            form.pricing.tcs = roundMoney(form.pricing.landcascade.tcs);
            form.pricing.subtotal.total = roundMoney(form.pricing.landcascade.land_total);
            form.pricing.profit.total = roundMoney(form.pricing.landcascade.land_profit);
            form.pricing.gst.total = roundMoney(form.pricing.landcascade.land_gst);
        }
    }

    let ftotal=0;
    let fadult=0;
    let finfant=0;
    let fchild=0;

    if (form.includes.flight) {
        ftotal=roundMoney(form.pricing.flightprofit.total)+roundMoney(form.pricing.flight.total)+roundMoney(form.pricing.flightgst.total);
        fadult=roundMoney(form.pricing.flightprofit.adult)+roundMoney(form.pricing.flight.adult)+roundMoney(form.pricing.flightgst.adult);
        finfant=roundMoney(form.pricing.flightprofit.infant)+roundMoney(form.pricing.flight.infant)+roundMoney(form.pricing.flightgst.infant);
        fchild=roundMoney(form.pricing.flightprofit.child)+roundMoney(form.pricing.flight.child)+roundMoney(form.pricing.flightgst.child);
    }

    form.pricing.flightsubtotal.total=roundMoney(ftotal);
    form.pricing.flightsubtotal.adult=roundMoney(fadult);
    form.pricing.flightsubtotal.infant=roundMoney(finfant);
    form.pricing.flightsubtotal.child=roundMoney(fchild);

    form.pricing.flighttotal=roundMoney(ftotal);

    const separateTotal = (form.pricing.separate_cascades || []).reduce(
        (sum, line) => roundMoney(sum + roundMoney(line.total)),
        0
    );
    // Legacy helicoptercascade still filled for DB columns; prefer sum of all separate cascades
    form.pricing.total=roundMoney(
        roundMoney(form.pricing.othertotal) + roundMoney(form.pricing.flighttotal) + separateTotal
    );
}

const updateflightprofitcost = () => {
    let total=0;

    total+=(parseFloat(form.adults || 0))*roundMoney(form.pricing.flightprofit.adult);
    total+=(parseFloat(form.childs || 0))*roundMoney(form.pricing.flightprofit.child);
    total+=(parseFloat(form.infants || 0))*roundMoney(form.pricing.flightprofit.infant);

    form.pricing.flightprofit.total=roundMoney(total);

    updateflightgstcost();
}

const updateflightgstcost = () => {
    const gstPct = FLIGHT_GST_PERCENT();
    let adultgst = roundMoney((roundMoney(form.pricing.flightprofit.adult) / 100) * gstPct);
    let childgst = roundMoney((roundMoney(form.pricing.flightprofit.child) / 100) * gstPct);
    let infantgst = roundMoney((roundMoney(form.pricing.flightprofit.infant) / 100) * gstPct);

    form.pricing.flightgst.adult = adultgst;
    form.pricing.flightgst.child = childgst;
    form.pricing.flightgst.infant = infantgst;

    form.pricing.flightgst.total = roundMoney(
        (parseFloat(form.adults || 0) * adultgst) +
        (parseFloat(form.childs || 0) * childgst) +
        (parseFloat(form.infants || 0) * infantgst)
    );
}


const addaddonmodel=ref(false);


const convertHMS=(value)=>{
    const sec = parseInt(value, 10); // convert value to number if it's string
    let hours   = Math.floor(sec / 3600); // get hours
    let minutes = Math.floor((sec - (hours * 3600)) / 60); // get minutes
    let seconds = sec - (hours * 3600) - (minutes * 60); //  get seconds
    // add 0 if value < 10; Example: 2 => 02
    if (hours   < 10) {hours   = "0"+hours;}
    if (minutes < 10) {minutes = "0"+minutes;}
    if (seconds < 10) {seconds = "0"+seconds;}
    if(hours>0){
        return hours+':'+minutes+':'+seconds;
    }
    else if(minutes>0){
        return minutes+':'+seconds;
    }
    else{
        return seconds;
    }
}





let enquiry=ref(null);

const fetdata=()=>{
    const loading = ElLoading.service({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)',
    });
    axios.get('/quotation/adddetails?eid='+eid+'&qid='+qid+'&bqid='+bqid+'&packages='+packagesFlag).then(function (response) {
        enquiry.value=response.data.enquiry;
        roomtypes.value=response.data.roomtypes;
        mealplans.value=response.data.mealplans;
        staytypes.value=response.data.staytypes;
        inclusions.value=response.data.inclusions;
        exclusions.value=response.data.exclusions;

        if (response.data.pricing_rates) {
            pricingRates.value = { ...DEFAULT_PRICING_RATES, ...response.data.pricing_rates };
        }
        if (response.data.addon_types) {
            addonTypes.value = response.data.addon_types;
        }

        let quotn=response.data.quotation;

        if(response.data.quotationtype==="new"){
            form.nights=quotn.nights;
            form.adults=quotn.adults;
            form.childs=quotn.childs;
            form.infants=quotn.infants;
            form.departure_date=quotn.departure_date;
            form.destinations=quotn.destinations;
            form.includes=quotn.includes;
        }
        else if(response.data.quotationtype==="edit" || response.data.quotationtype==="packages"){
            form.nights=quotn.nights;
            form.adults=quotn.adults;
            form.childs=quotn.childs;
            form.infants=quotn.infants;
            form.departure_date=quotn.departure_date;
            form.destinations=quotn.destinations;
            form.includes=quotn.includes;
            form.hotels=quotn.stays || [];
            form.cities=quotn.cities || [];
            form.flights=quotn.flights || [];
            form.inclusions=quotn.inclusions || [];
            form.exclusions=quotn.exclusions || [];
            form.insurancedetails=quotn.insurancedetails;
            form.visadetails=quotn.visadetails;
            form.addons=quotn.addons || [];
            form.itineraries=quotn.itineraries || [];
            form.banner_image=quotn.banner_image || '';
            form.pricing=quotn.pricing || form.pricing;
            const savedCalc = (quotn.pricing && quotn.pricing.calculation) || {};
            form.discount_type = quotn.discount_type || savedCalc.discount_type || 'percent';
            form.discount_value = (quotn.discount_value !== undefined && quotn.discount_value !== null && quotn.discount_value !== '')
                ? quotn.discount_value
                : (savedCalc.discount_value || 0);
            if (quotn.pricing && quotn.pricing.rates_used) {
                pricingRates.value = { ...DEFAULT_PRICING_RATES, ...quotn.pricing.rates_used };
            }
            if (quotn.pricing && quotn.pricing.tax_application) {
                pricingRates.value.taxes_absorbed = quotn.pricing.tax_application === 'absorbed' ? 1 : 0;
            }
            if (!form.pricing.landcascade) {
                form.pricing.landcascade = emptyLandCascade();
            }
            if (!form.pricing.helicoptercascade) {
                form.pricing.helicoptercascade = emptyHelicopterCascade();
            }
            if (!form.pricing.separate_cascades) {
                form.pricing.separate_cascades = [];
            }
            if (!form.pricing.landcascade.markup_addons) {
                form.pricing.landcascade.markup_addons = [];
            }
            if (response.data.is_draft && response.data.draft_id) {
                draftEncryptedId.value = response.data.draft_id;
                syncDraftUrl(response.data.draft_id);
            } else if (response.data.draft_id) {
                draftEncryptedId.value = response.data.draft_id;
            } else {
                // Editing a published quote: first autosave will create a new Draft
                draftEncryptedId.value = null;
            }
            if (response.data.resume_draft) {
                ElMessage({
                    message: 'Resumed draft',
                    type: 'info',
                });
            }
            basicdetailsentered.value=true;
            // Recalculate land cascade + flight profit/GST on load
            nextTick(() => {
                rescaleTransportationAddons({ updateLand: false });
                updatestaycost();
                updatelandcost();
                updatevisacost();
                updateinsurancecost();
                updateflightcost();
                applyLandCascade();
            });


        }
        else if(response.data.quotationtype==="bestmatching"){
            form.nights=quotn.nights;
            form.adults=quotn.adults;
            form.childs=quotn.childs;
            form.infants=quotn.infants;
            form.departure_date=quotn.departure_date;
            form.destinations=quotn.destinations;
            form.includes=quotn.includes;
            form.hotels=quotn.stays;
            form.cities=quotn.cities;
            form.inclusions=quotn.inclusions;
            form.exclusions=quotn.exclusions;
            form.insurancedetails=quotn.insurancedetails;
            form.visadetails=quotn.visadetails;
            form.addons=quotn.addons;
            form.itineraries=quotn.itineraries;
            form.banner_image=quotn.banner_image || '';
            form.pricing=quotn.pricing;
            basicdetailsentered.value=true;
            resetprices();

        }

        if (form.destinations && form.destinations.length) {
            prefetchDestinationTypes(form.destinations);
        }

        loadWebsitePackages();
        loading.close()

    })
        .catch(function (error) {
            loading.close()
        });
}
const appendUniqueText = (current, incoming) => {
    const next = Array.isArray(current) ? [...current] : [];
    const seen = new Set(next.map((item) => String(item).trim().toLowerCase()));
    (incoming || []).forEach((item) => {
        const key = String(item).trim().toLowerCase();
        if (!key || seen.has(key)) {
            return;
        }
        seen.add(key);
        next.push(item);
    });
    return next;
};

const appendUniqueCities = (current, incoming) => {
    const next = Array.isArray(current) ? [...current] : [];
    const seen = new Set(next.map((city) => String(city && city.destination ? city.destination : '').trim().toLowerCase()));
    (incoming || []).forEach((city) => {
        const name = String(city && city.destination ? city.destination : '').trim();
        const key = name.toLowerCase();
        if (!key || seen.has(key)) {
            return;
        }
        seen.add(key);
        next.push(city);
    });
    return next;
};

const asList = (value) => Array.isArray(value) ? value : [];

const isPackageFlight = (flight) => {
    const id = String(flight && flight.id ? flight.id : '');
    return !!(flight && flight.websitePackage) || id.startsWith('pkg-flight-');
};

const isPackageStay = (hotel) => {
    const id = String(hotel && hotel.id ? hotel.id : '');
    return !!(hotel && hotel.websitePackage) || id.startsWith('pkg-hotel-');
};

const applyPackageQuotation = (quotn) => {
    const stamp = Date.now();
    const packageFlights = asList(quotn.flights).map((flight, index) => ({
        ...flight,
        websitePackage: true,
        id: 'pkg-flight-' + stamp + '-' + index,
    }));
    const packageStays = asList(quotn.stays).map((hotel, index) => ({
        ...hotel,
        websitePackage: true,
        id: 'pkg-hotel-' + stamp + '-' + index,
    }));
    const packageAddons = asList(quotn.addons);
    const packageDays = asList(quotn.itineraries);

    if (!Array.isArray(form.flights)) {
        form.flights = [];
    }
    if (!Array.isArray(form.hotels)) {
        form.hotels = [];
    }
    if (!Array.isArray(form.addons)) {
        form.addons = [];
    }

    const keptFlights = form.flights.filter((flight) => !isPackageFlight(flight));
    form.flights.splice(0, form.flights.length, ...keptFlights, ...packageFlights);

    const keptStays = form.hotels.filter((hotel) => !isPackageStay(hotel));
    form.hotels.splice(0, form.hotels.length, ...keptStays, ...packageStays);

    const keptAddons = form.addons.filter((addon) => !String(addon && addon.id ? addon.id : '').startsWith('pkg-'));
    form.addons.splice(0, form.addons.length, ...keptAddons, ...packageAddons);

    applyingWebsitePackage.value = true;

    const keptDays = (form.itineraries || []).filter((day) => !day || !day.websitePackage);
    const lastDay = keptDays.reduce((max, day) => Math.max(max, Number(day && day.day) || 0), 0);
    const appendedDays = packageDays.map((day, index) => ({
        ...day,
        websitePackage: true,
        day: lastDay + index + 1,
    }));
    form.itineraries = [...keptDays, ...appendedDays];
    renumberItineraryDays();
    if (form.itineraries.length > 0) {
        form.nights = form.itineraries.length - 1;
    }

    form.destinations = appendUniqueText(form.destinations, quotn.destinations);
    form.cities = appendUniqueCities(form.cities, quotn.cities);
    form.inclusions = appendUniqueText(form.inclusions, quotn.inclusions);
    form.exclusions = appendUniqueText(form.exclusions, quotn.exclusions);

    if (packageFlights.length) {
        form.includes.flight = true;
    }
    if (packageStays.length) {
        form.includes.hotel = true;
    }
    if (packageDays.length || packageAddons.length) {
        form.includes.landpackage = true;
    }
    if (quotn.banner_image) {
        form.banner_image = quotn.banner_image;
    }
    flightListKey.value += 1;
    hotelListKey.value += 1;

    basicdetailsentered.value = true;
    if (form.destinations && form.destinations.length) {
        prefetchDestinationTypes(form.destinations);
    }
    nextTick(() => {
        applyingWebsitePackage.value = false;
        rescaleTransportationAddons({ updateLand: false });
        updatestaycost();
        updatelandcost();
        updatevisacost();
        updateinsurancecost();
        updateflightcost();
        applyLandCascade();
    });
};

const loadWebsitePackages = () => {
    websitePackagesLoading.value = true;
    packageApplyError.value = '';
    axios.get('/enquiry/newquote/public-packages').then(function (response) {
        websitePackages.value = response.data.packages || [];
        websitePackagesLoading.value = false;
    }).catch(function (error) {
        websitePackagesLoading.value = false;
        packageApplyError.value = (error.response && error.response.data && error.response.data.message) || 'Unable to load website packages.';
    });
};

const packageErrorMessage = (error) => {
    const data = error.response && error.response.data;
    if (data && data.errors) {
        const first = Object.values(data.errors)[0];
        if (Array.isArray(first) && first[0]) {
            return first[0];
        }
    }
    return (data && data.message) || 'Unable to load package details.';
};

const searchOriginCities = (query) => {
    const key = (query || '').trim();
    if (key.length < 1) {
        return;
    }
    originCityLoading.value = true;
    axios.post('/searchairport', { key }).then(function (response) {
        const rows = ((response.data && response.data.data) || [])
            .filter((row) => row && row.code && row.city)
            .map((row) => ({
                code: String(row.code).toUpperCase(),
                city: row.city,
                airport: row.airport || '',
            }));
        const selected = originCities.value.find((row) => row.code === packageOrigin.value);
        originCities.value = selected && !rows.some((row) => row.code === selected.code)
            ? [selected, ...rows]
            : rows;
        originCityLoading.value = false;
    }).catch(function () {
        originCityLoading.value = false;
    });
};

const applySelectedPackages = () => {
    if (!enquiry.value) {
        return;
    }
    const origin = (packageOrigin.value || '').trim().toUpperCase();
    const travelDate = form.departure_date;
    if (selectedPackageCodes.value.length === 0) {
        packageApplyError.value = 'Select at least one package.';
        return;
    }
    if (!origin) {
        packageApplyError.value = 'Select the origin city.';
        return;
    }
    if (!travelDate) {
        packageApplyError.value = 'Select a departure date.';
        return;
    }
    packageOrigin.value = origin;
    packageApplyLoading.value = true;
    packageApplyError.value = '';
    axios.post('/enquiry/newquote/public-package-details', {
        enquiry_id: Number(enquiry.value.id),
        package_codes: selectedPackageCodes.value.slice(),
        origin: origin,
        travel_date: travelDate,
        adults: Number(form.adults) || 0,
        children: Number(form.childs) || 0,
        infants: Number(form.infants) || 0,
    }).then(function (response) {
        packageApplyLoading.value = false;
        if (!response.data.quotation) {
            packageApplyError.value = 'Package details did not include a quotation.';
            return;
        }
        applyPackageQuotation(response.data.quotation);
        ElMessage({
            message: 'Selected packages added to this quotation.',
            type: 'success',
        });
    }).catch(function (error) {
        packageApplyLoading.value = false;
        packageApplyError.value = packageErrorMessage(error);
    });
};

const syncDraftUrl = (encryptedId) => {
    if (!encryptedId || typeof window === 'undefined') {
        return;
    }
    try {
        const url = new URL(window.location.href);
        url.searchParams.set('qid', encryptedId);
        window.history.replaceState({}, '', url.toString());
    } catch (e) {
        // ignore URL sync failures
    }
};

const buildPersistPayload = () => {
    const charged = chargedTaxes.value;
    form.pricing.calculation = {
        land_before_gst: charged.land_before_gst,
        discount_type: charged.discount_type,
        discount_value: charged.discount_value,
        discount_amount: charged.discount_amount,
        pre_tax_discount: charged.pre_tax_discount,
        land_after_discount: charged.land_after_discount,
        land_gst_percent: charged.land_gst_percent,
        land_gst: charged.land_gst,
        tcs_percent: charged.tcs_percent,
        tcs_included: charged.tcs_included,
        tcs: charged.tcs,
        land_total: charged.land_total,
        flight_fare: charged.flight_fare,
        flight_service: charged.flight_service,
        flight_gst_percent: charged.flight_gst_percent,
        flight_gst_adult: charged.flight_gst_adult,
        flight_gst_child: charged.flight_gst_child,
        flight_gst_infant: charged.flight_gst_infant,
        flight_gst: charged.flight_gst,
        flight_total: charged.flight_total,
        separate_lines: charged.separate_lines,
        separate_gst: charged.separate_gst,
        helicopter_gst: charged.helicopter_gst,
        tax_application: charged.tax_application,
        customer_total: charged.customer_total,
    };
    form.pricing.tax_application = charged.tax_application;
    form.pricing.land_gst_charged = charged.land_gst;
    form.pricing.tcs_charged = charged.tcs;
    form.pricing.flight_gst_charged = charged.flight_gst;
    form.pricing.helicopter_gst_charged = charged.helicopter_gst;
    form.pricing.total = charged.customer_total;
    form.pricing.rates_used = { ...pricingRates.value };
    form.pricing.addon_types_used = addonTypes.value.map((t) => ({ ...t }));

    return {
        ...form,
        hotels: hotelsForSubmit(),
        draft_id: draftEncryptedId.value || undefined,
    };
};

const runAutosave = async () => {
    if (!basicdetailsentered.value || publishing.value || autosaveInFlight || !autosaveReady.value) {
        return;
    }
    autosaveInFlight = true;
    autosaveStatus.value = 'saving';
    try {
        const payload = buildPersistPayload();
        const response = await axios.post('/enquiry/newquote/autosave', payload);
        draftEncryptedId.value = response.data.encrypted_id;
        syncDraftUrl(response.data.encrypted_id);
        autosaveSavedAt.value = response.data.saved_at || new Date().toISOString();
        autosaveStatus.value = 'saved';
        autosaveDirty.value = false;
    } catch (error) {
        autosaveStatus.value = 'error';
    } finally {
        autosaveInFlight = false;
    }
};

const scheduleAutosave = () => {
    if (!basicdetailsentered.value || !autosaveReady.value || publishing.value) {
        return;
    }
    autosaveDirty.value = true;
    if (autosaveTimer) {
        clearTimeout(autosaveTimer);
    }
    autosaveTimer = setTimeout(() => {
        runAutosave();
    }, 2000);
};

const ensureValidActiveTab = () => {
    const includes = form.includes || {};
    const allowed = ['basic', 'pricing'];
    if (includes.landpackage) {
        allowed.push('destinations', 'daywise', 'addons');
    }
    if (includes.flight) {
        allowed.push('flights');
    }
    if (includes.hotel || includes.cruise) {
        allowed.push('stays');
    }
    if (includes.visa) {
        allowed.push('visa');
    }
    if (includes.insurance) {
        allowed.push('insurance');
    }
    if (includes.landpackage || includes.hotel || includes.cruise || includes.visa || includes.insurance) {
        allowed.push('inclusions');
    }
    if (!allowed.includes(activeQuoteTab.value)) {
        activeQuoteTab.value = 'basic';
    }
};

watch(
    () => form.includes,
    () => {
        ensureValidActiveTab();
    },
    { deep: true }
);

watch(
    form,
    () => {
        if (!autosaveReady.value || !basicdetailsentered.value) {
            return;
        }
        scheduleAutosave();
    },
    { deep: true }
);

watch(basicdetailsentered, (entered) => {
    if (!entered) {
        autosaveReady.value = false;
        return;
    }
    // Delay so load-time form mutations do not create an immediate draft rewrite.
    setTimeout(() => {
        if (basicdetailsentered.value && !publishing.value) {
            autosaveReady.value = true;
            autosaveDirty.value = false;
        }
    }, 800);
});

onMounted(() => {
    window.addEventListener('beforeunload', onBeforeUnload);
});

fetdata();



const submitForm = async (formEl) => {

    if (!formEl) return
    if (form.includes.landpackage && Array.isArray(form.itineraries) && form.itineraries.length > 0) {
        applyingWebsitePackage.value = true;
        form.nights = form.itineraries.length - 1;
        nextTick(() => {
            applyingWebsitePackage.value = false;
        });
    }
    await formEl.validate((valid, fields) => {

        if (valid) {
            if (quotationDiscount.value.error) {
                ElMessage({
                    message: quotationDiscount.value.error,
                    type: 'error',
                });
                return;
            }

            const loading = ElLoading.service({
                lock: true,
                text: 'Loading',
                background: 'rgba(0, 0, 0, 0.7)',
            });

            publishing.value = true;
            if (autosaveTimer) {
                clearTimeout(autosaveTimer);
                autosaveTimer = null;
            }
            const payload = buildPersistPayload();

            axios.post('/enquiry/newquote/publish', payload).then(function (response) {
                autosaveDirty.value = false;
                ElMessage({
                    message: 'Quotation Added Sucessfully.',
                    type: 'success',
                })

                window.location.href='/viewenquiry?id='+enquiry.value.encryptedid;

            })
                .catch(function (error) {
                    publishing.value = false;
                    loading.close();
                    const message = (error.response && error.response.data && error.response.data.message)
                        ? error.response.data.message
                        : 'Could not save the quotation.';
                    ElMessage({
                        message,
                        type: 'error',
                    });
                });

        }
    })
}


const showbeastmatching=ref(false);

const autofillitenary=()=>{
    const loading = ElLoading.service({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)',
    });
    axios.post('/enquiry/newquote/autofillitenary',form).then(function (response) {
        var data=response.data;
        form.itineraries.map(function(value, key) {
            value.title=data[value.day].title;
            value.description=data[value.day].description;
        });

        loading.close()

    })
        .catch(function (error) {
            loading.close()
        });
}

const validateProfit = (rule, value, callback) => {
    // Land profit is formula-driven (cascade); no manual minimum check
    callback();
}



const resetprices=()=>{
    form.flights.forEach((item, index) => {
        item.pricing={ "total": 0, "adult": 0, "child": 0, "infant": 0}
    });


    form.hotels.forEach((item, index) => {
        item.pricing={ "total": 0, "adult": 0, "child": 0, "infant": 0}
    });

    form.addons.forEach((item, index) => {
        item.pricing={ "total": 0, "adult": 0, "child": 0, "infant": 0}
    });


    form.itineraries.forEach((item, index) => {
        item.transfers.forEach((item1, index1) => {
            item1.pricing={ "total": 0, "adult": 0, "child": 0, "infant": 0}
        });
        item.activities.forEach((item1, index1) => {
            item1.pricing={ "total": 0, "adult": 0, "child": 0, "infant": 0}
        });
    });

    form.pricing={ "landpackage": { "adult": 0, "child": 0, "infant": 0, "total": 0 }, "flight": { "adult": 0, "child": 0, "infant": 0, "total": 0 }, "visa": { "adult": 0, "child": 0, "infant": 0, "total": 0 }, "cruise": { "adult": 0, "child": 0, "infant": 0, "total": 0 }, "hotel": { "adult": 0, "child": 0, "infant": 0, "total": 0 }, "insurance": { "adult": 0, "child": 0, "infant": 0, "total": 0 }, "subtotal": { "adult": 0, "child": 0, "infant": 0, "total": 0 }, "flightsubtotal": { "adult": 0, "child": 0, "infant": 0, "total": 0 }, "profit": { "adult": 0, "child": 0, "infant": 0, "total": 0 }, "flightprofit": { "adult": 0, "child": 0, "infant": 0, "total": 0 }, "gst": { "adult": 0, "child": 0, "infant": 0, "total": 0 }, "flightgst": { "adult": 0, "child": 0, "infant": 0, "total": 0 }, "tcs": 0, "othertotal": 0, "flighttotal": 0, "total": 0, "tcsincluded": false, "landcascade": emptyLandCascade(), "helicoptercascade": emptyHelicopterCascade(), "separate_cascades": [] };


}

</script>

<template>
    <el-container fluid v-if="enquiry!=null">
        <el-header>
            <el-menu

                class="el-menu-demo"
                mode="horizontal"
                background-color="#545c64"
                text-color="#fff"
                active-text-color="#ffd04b"
                :ellipsis="false"
            >
                <el-menu-item >TRIP ID - {{enquiry.id}}</el-menu-item>

                <el-menu-item class="fwww">

                </el-menu-item>
                <el-menu-item  class="grey-bn">{{ convertHMS(form.time) }} </el-menu-item>

                <el-menu-item  class="white-bn" >
                    <a :href="'/enquiry/newquote/bestmatchingquotes?enqid='+enquiry.encryptedid"> Best Matching Quotes</a>
                </el-menu-item>
                <el-menu-item class="grey-bn">
                    <a  :href="'/viewenquiry?id='+enquiry.encryptedid">Back</a>
                </el-menu-item>



            </el-menu>
        </el-header>
    </el-container>

    <el-main  v-if="enquiry!=null">
        <el-row :gutter="20">
            <el-col class="pr-w100" :span="5">
                <el-row :gutter="20">
                    <el-col :span="24">
                        <TravellerDetailsInfo  :enquiry="enquiry" />
                    </el-col>
                    <el-col :span="24" class="mt-2">
                        <TravellerRequirementInfo  :enquiry="enquiry" />
                    </el-col>
                </el-row>
            </el-col>
            <el-col class="pr-w100" :span="19">
                <el-form
                    ref="ruleFormRef"
                    :model="form"
                    status-icon
                    :rules="rules"
                    label-width="auto"
                    class="demo-ruleForm"
                    label-position="top"
                    size="small"
                    :scroll-to-error="true"

                >
                    <el-row v-if="!basicdetailsentered" :gutter="20">
                        <el-col :span="24">
                            <el-card class="mini-box-card  box-d-card" >
                                <template class="mini-card-header" #header>
                                    <span>Basic Details</span>

                                </template>
                                <el-row :gutter="20">

                                    <el-col :span="24">
                                        <el-form-item   label="Services Required" prop="packageservices">
                                            <el-checkbox v-model="form.includes.landpackage"  label="Land Package" size="large"  />
                                            <el-checkbox v-model="form.includes.hotel"  label="Hotel" size="large"  />
                                            <el-checkbox v-model="form.includes.flight"  label="Flight" size="large"  />
                                            <el-checkbox v-model="form.includes.visa"  label="Visa" size="large"  />
                                            <el-checkbox v-model="form.includes.cruise"  label="Cruise" size="large"  />
                                            <el-checkbox v-model="form.includes.insurance"  label="Travel Insurance" size="large"  />

                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="3" v-if="form.includes.landpackage || form.includes.hotel || form.includes.cruise">
                                        <el-form-item label="Nights" prop="nights">
                                            <el-input-number v-model="form.nights" :min="0" @change="nightchange()" placeholder="Nights" />

                                        </el-form-item>

                                    </el-col>
                                    <el-col :span="3" >
                                        <el-form-item label="Adults" prop="adults">
                                            <el-input-number v-model="form.adults" :min="1"  placeholder="Adults" />

                                        </el-form-item>

                                    </el-col>
                                    <el-col :span="3" >
                                        <el-form-item label="Child" prop="childs">
                                            <el-input-number v-model="form.childs" :min="0"  placeholder="Child" />

                                        </el-form-item>

                                    </el-col>
                                    <el-col :span="3" >
                                        <el-form-item label="Infants" prop="infants">
                                            <el-input-number v-model="form.infants" :min="0"  placeholder="Infants" />

                                        </el-form-item>

                                    </el-col>
                                    <el-col :span="3" >
                                        <el-form-item label="Departure Date" prop="departure_date">
                                            <el-date-picker

                                                v-model="form.departure_date"
                                                type="date"
                                                placeholder="Select Date"
                                                format="DD-MM-YYYY"
                                                value-format="YYYY-MM-DD"
                                            />

                                        </el-form-item>

                                    </el-col>
                                    <el-col :span="9" >
                                        <el-form-item label="Destinations" prop="destinations">

                                            <el-select
                                                v-model="form.destinations"
                                                filterable
                                                allow-create
                                                remote
                                                multiple
                                                placeholder="Please enter a keyword"
                                                :remote-method="getDestinations"
                                                :loading="destinationloading"
                                                style="width: 100%"
                                            >
                                                <el-option
                                                    v-for="item in alldestinations"
                                                    :key="item"
                                                    :label="item"
                                                    :value="item"
                                                />
                                            </el-select>

                                        </el-form-item>
                                    </el-col>

                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="9">
                                        <el-form-item label="Website Packages">
                                            <el-select
                                                v-model="selectedPackageCodes"
                                                multiple
                                                filterable
                                                collapse-tags
                                                collapse-tags-tooltip
                                                placeholder="Select packages"
                                                :loading="websitePackagesLoading"
                                                style="width: 100%"
                                            >
                                                <el-option
                                                    v-for="pkg in websitePackages"
                                                    :key="pkg.packageCode"
                                                    :label="pkg.title + ' (' + pkg.packageCode + ')'"
                                                    :value="pkg.packageCode"
                                                />
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="4">
                                        <el-form-item label="Origin airport">
                                            <el-select
                                                v-model="packageOrigin"
                                                filterable
                                                remote
                                                clearable
                                                placeholder="Search city"
                                                :remote-method="searchOriginCities"
                                                :loading="originCityLoading"
                                                style="width: 100%"
                                            >
                                                <el-option
                                                    v-for="item in originCities"
                                                    :key="item.code"
                                                    :label="item.city"
                                                    :value="item.code"
                                                >
                                                    <span>{{ item.city }}</span>
                                                    <span v-if="item.airport" style="float: right; color: var(--el-text-color-secondary); font-size: 12px">{{ item.airport }}</span>
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="4">
                                        <el-form-item label=" ">
                                            <el-button
                                                type="primary"
                                                :disabled="packageApplyLoading"
                                                :loading="packageApplyLoading"
                                                @click="applySelectedPackages"
                                            >
                                                Add to quotation
                                            </el-button>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-alert v-if="packageApplyError" class="mb-2" type="error" :title="packageApplyError" :closable="false" />

                                <template #footer>
                                    <div class="text-right">
                                        <el-button type="primary" @click="gotostep2(ruleFormRef)">Create Quote</el-button>
                                    </div>
                                </template>
                            </el-card>

                        </el-col>



                    </el-row>
                    <el-row v-else :gutter="20">
                        <el-col :span="24">
                        <div class="quote-toolbar">
                            <div class="quote-autosave-status">
                                <el-text v-if="autosaveStatus === 'saving'" type="info" size="small">Saving…</el-text>
                                <el-text v-else-if="autosaveStatus === 'saved'" type="success" size="small">Draft saved {{ autosaveSavedAt }}</el-text>
                                <el-text v-else-if="autosaveStatus === 'error'" type="danger" size="small">Save failed</el-text>
                                <el-text v-else type="info" size="small">Autosave on</el-text>
                            </div>
                            <div class="quote-toolbar-actions">
                                <el-button size="small" :loading="autosaveStatus === 'saving'" @click="runAutosave">Save draft</el-button>
                                <el-button type="primary" :loading="publishing" @click="submitForm(ruleFormRef)">Submit</el-button>
                            </div>
                        </div>
                            <el-tabs v-model="activeQuoteTab" type="border-card" class="quote-section-tabs">
                        <el-tab-pane label="Basic" name="basic">
<el-card class="mini-box-card  box-d-card" >
                                <template class="mini-card-header" #header>
                                    <span>Basic Details</span>

                                </template>
                                <el-row :gutter="20">

                                    <el-col :span="24">
                                        <el-form-item   label="Services Required" prop="packageservices">
                                            <el-checkbox v-model="form.includes.landpackage"  label="Land Package" size="large"  />
                                            <el-checkbox v-model="form.includes.hotel"  label="Hotel" size="large"  />
                                            <el-checkbox v-model="form.includes.flight"  label="Flight" size="large"  />
                                            <el-checkbox v-model="form.includes.visa"  label="Visa" size="large"  />
                                            <el-checkbox v-model="form.includes.cruise"  label="Cruise" size="large"  />
                                            <el-checkbox v-model="form.includes.insurance"  label="Travel Insurance" size="large"  />

                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="3" v-if="form.includes.landpackage || form.includes.hotel || form.includes.cruise">
                                        <el-form-item label="Nights" prop="nights">
                                            <el-input-number v-model="form.nights" :min="0" @change="nightchange()" placeholder="Nights" />

                                        </el-form-item>

                                    </el-col>
                                    <el-col :span="3" >
                                        <el-form-item label="Adults" prop="adults">
                                            <el-input-number v-model="form.adults" :min="1"  placeholder="Adults" @change="onTravellerCountChange"/>

                                        </el-form-item>

                                    </el-col>
                                    <el-col :span="3" >
                                        <el-form-item label="Child" prop="childs">
                                            <el-input-number v-model="form.childs" :min="0"  placeholder="Child" @change="onTravellerCountChange" />

                                        </el-form-item>

                                    </el-col>
                                    <el-col :span="3" >
                                        <el-form-item label="Infants" prop="infants">
                                            <el-input-number v-model="form.infants" :min="0"  placeholder="Infants" @change="onTravellerCountChange"/>

                                        </el-form-item>

                                    </el-col>
                                    <el-col :span="3" >
                                        <el-form-item label="Departure Date" prop="departure_date">
                                            <el-date-picker

                                                v-model="form.departure_date"
                                                type="date"
                                                placeholder="Select Date"
                                                format="DD-MM-YYYY"
                                                value-format="YYYY-MM-DD"
                                            />

                                        </el-form-item>

                                    </el-col>
                                    <el-col :span="9" >
                                        <el-form-item label="Destinations" prop="destinations">

                                            <el-select
                                                v-model="form.destinations"
                                                filterable
                                                allow-create
                                                remote
                                                multiple
                                                placeholder="Please enter a keyword"
                                                :remote-method="getDestinations"
                                                :loading="destinationloading"
                                                style="width: 100%"
                                            >
                                                <el-option
                                                    v-for="item in alldestinations"
                                                    :key="item"
                                                    :label="item"
                                                    :value="item"
                                                />
                                            </el-select>

                                        </el-form-item>
                                    </el-col>

                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="9">
                                        <el-form-item label="Website Packages">
                                            <el-select
                                                v-model="selectedPackageCodes"
                                                multiple
                                                filterable
                                                collapse-tags
                                                collapse-tags-tooltip
                                                placeholder="Select packages"
                                                :loading="websitePackagesLoading"
                                                style="width: 100%"
                                            >
                                                <el-option
                                                    v-for="pkg in websitePackages"
                                                    :key="pkg.packageCode"
                                                    :label="pkg.title + ' (' + pkg.packageCode + ')'"
                                                    :value="pkg.packageCode"
                                                />
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="4">
                                        <el-form-item label="Origin airport">
                                            <el-select
                                                v-model="packageOrigin"
                                                filterable
                                                remote
                                                clearable
                                                placeholder="Search city"
                                                :remote-method="searchOriginCities"
                                                :loading="originCityLoading"
                                                style="width: 100%"
                                            >
                                                <el-option
                                                    v-for="item in originCities"
                                                    :key="item.code"
                                                    :label="item.city"
                                                    :value="item.code"
                                                >
                                                    <span>{{ item.city }}</span>
                                                    <span v-if="item.airport" style="float: right; color: var(--el-text-color-secondary); font-size: 12px">{{ item.airport }}</span>
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="4">
                                        <el-form-item label=" ">
                                            <el-button
                                                type="primary"
                                                :disabled="packageApplyLoading"
                                                :loading="packageApplyLoading"
                                                @click="applySelectedPackages"
                                            >
                                                Add to quotation
                                            </el-button>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-alert v-if="packageApplyError" class="mb-2" type="error" :title="packageApplyError" :closable="false" />


                            </el-card>
                        </el-tab-pane>

                        <el-tab-pane v-if="form.includes.landpackage" label="Destinations" name="destinations">
<el-card class="mini-box-card  box-d-card mt-4" >
                                <template class="mini-card-header" #header>
                                    <span>Destinations</span>
                                    <el-button class="ml-2" size="small"  @click.prevent="addCity()">
                                        Add
                                    </el-button>
                                </template>
                                <el-row :gutter="20">
                                    <el-col :span="8" v-for="(city, index) in form.cities">
                                        <el-row  :gutter="10">
                                            <el-col :span="12" >
                                                <el-form-item
                                                    :prop="'cities.' + index + '.destination'"
                                                    :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }"
                                                >
                                                    <el-select
                                                        v-model="city.destination"
                                                        filterable
                                                        remote
                                                        allow-create
                                                        placeholder="Please enter a keyword"
                                                        :remote-method="getDestinations"
                                                        :loading="destinationloading"
                                                        style="width: 100%"
                                                    >
                                                        <el-option
                                                            v-for="item in alldestinations"
                                                            :key="item"
                                                            :label="item"
                                                            :value="item"
                                                        />
                                                    </el-select>



                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12" >
                                                <el-form-item
                                                    :prop="'cities.' + index + '.nights'"
                                                    :rules="{
                                                            required: true,
                                                            message: 'Required',
                                                            trigger: ['blur','change'],
                                                          }"
                                                >
                                                    <el-row  :gutter="10">
                                                        <el-col :span="16" >
                                                            <el-input v-model="city.nights" type="number">
                                                                <template #append>N</template>
                                                            </el-input>
                                                        </el-col>
                                                        <el-col :span="8" >
                                                            <el-button size="small" type="danger" class="mr-3" @click.prevent="removeCity(city)">
                                                                Delete
                                                            </el-button>
                                                        </el-col>
                                                    </el-row>


                                                </el-form-item>
                                            </el-col>
                                        </el-row>

                                    </el-col>

                                </el-row>
                            </el-card>
                        </el-tab-pane>

                        <el-tab-pane v-if="form.includes.flight" label="Flights" name="flights">
<el-card class="mini-box-card  box-d-card mt-2" >
                                <template class="mini-card-header" #header>
                                    <span>Flights</span>
                                    <el-text class="ml-2" size="small" type="info" v-if="form.flights.length > 1">Drag the handle to rearrange</el-text>

                                    <el-dropdown class="ml-2">
                                        <el-button size="small" >
                                            Add Flight
                                            <el-icon class="el-icon--right">
                                                <arrow-down />
                                            </el-icon>
                                        </el-button>
                                        <template #dropdown>
                                            <el-dropdown-menu>
                                                <el-dropdown-item @click.prevent="addmanualflightsmodel=true">Mannual</el-dropdown-item>
                                                <el-dropdown-item @click.prevent="searchflightsmodel=true">API</el-dropdown-item>
                                            </el-dropdown-menu>
                                        </template>
                                    </el-dropdown>

                                </template>

                                <div
                                    v-for="(flight,index) in form.flights"
                                    :key="flight.id || ('flight-' + index)"
                                    class="quote-sortable-item"
                                    :class="{ 'is-drag-over': dragState.type === 'flights' && dragState.over === index && dragState.from !== index }"
                                    @dragover="onItemDragOver($event, 'flights', index)"
                                    @drop="onItemDrop($event, 'flights', index)"
                                >
                                    <div
                                        class="quote-drag-handle"
                                        draggable="true"
                                        title="Drag to rearrange"
                                        @dragstart="onItemDragStart($event, 'flights', index)"
                                        @dragend="onItemDragEnd"
                                    >
                                        <el-icon><Rank /></el-icon>
                                    </div>
                                    <div class="quote-sortable-body">
                                        <div v-if="flight.packageMissing" class="package-missing-card">
                                            <div class="package-missing-title">Flight not found</div>
                                            <div class="package-missing-route" v-if="flight.data && (flight.data.route || flight.data.date)">
                                                <span v-if="flight.data.route">{{ flight.data.route }}</span>
                                                <span v-if="flight.data.date"> · {{ flight.data.date }}</span>
                                            </div>
                                            <div class="package-missing-message">{{ flight.packageError }}</div>
                                            <el-button type="danger" size="small" @click="removeflight(flight)">Remove</el-button>
                                        </div>
                                        <mannual-flight-card-edit v-else-if="flight.source==='mannual'" :index="index" :flight="flight"   @removeflight="removeflight" :form="form" ></mannual-flight-card-edit>
                                        <single-flight-card-edit  v-else-if="flight.source==='api' && flight.type==='single'" :index="index" :flight="flight"  @removeflight="removeflight" :form="form" ></single-flight-card-edit>
                                        <combo-flight-card-edit  v-else-if="flight.source==='api' && flight.type==='combo'" :index="index" :flight="flight"  @removeflight="removeflight" :form="form" ></combo-flight-card-edit>
                                    </div>
                                </div>



                            </el-card>
                        </el-tab-pane>

                        <el-tab-pane v-if="form.includes.hotel || form.includes.cruise" label="Stays" name="stays">
<el-card class="mini-box-card  box-d-card mt-2" >
                                <template class="mini-card-header" #header>
                                    <span>Stays</span>
                                    <el-text class="ml-2" size="small" type="info" v-if="form.hotels.length > 1">Drag the handle to rearrange</el-text>

                                    <el-dropdown class="ml-2">
                                        <el-button size="small" >
                                            Add Stay
                                            <el-icon class="el-icon--right">
                                                <arrow-down />
                                            </el-icon>
                                        </el-button>
                                        <template #dropdown>
                                            <el-dropdown-menu>
                                                <el-dropdown-item @click.prevent="addmanualhotelmodel=true">Mannual</el-dropdown-item>
                                                <el-dropdown-item v-if="form.includes.hotel" @click.prevent="searchhotelmodel=true">API</el-dropdown-item>
                                            </el-dropdown-menu>
                                        </template>
                                    </el-dropdown>

                                </template>

                                <div
                                    v-for="(hotel,index) in form.hotels"
                                    :key="hotel.id || ('hotel-' + index)"
                                    class="quote-sortable-item"
                                    :class="{ 'is-drag-over': dragState.type === 'hotels' && dragState.over === index && dragState.from !== index }"
                                    @dragover="onItemDragOver($event, 'hotels', index)"
                                    @drop="onItemDrop($event, 'hotels', index)"
                                >
                                    <div
                                        class="quote-drag-handle"
                                        draggable="true"
                                        title="Drag to rearrange"
                                        @dragstart="onItemDragStart($event, 'hotels', index)"
                                        @dragend="onItemDragEnd"
                                    >
                                        <el-icon><Rank /></el-icon>
                                    </div>
                                    <div class="quote-sortable-body">
                                        <div v-if="hotel.packageMissing" class="package-missing-card">
                                            <div class="package-missing-title">Stay not found</div>
                                            <div class="package-missing-route" v-if="hotel.data && hotel.data.name && hotel.data.name !== 'Stay not found'">
                                                {{ hotel.data.name }}<span v-if="hotel.data.city"> · {{ hotel.data.city }}</span>
                                            </div>
                                            <div class="package-missing-route" v-if="hotel.data && (hotel.data.checkIn || hotel.data.checkOut)">
                                                <span v-if="hotel.data.checkIn">Check-in: {{ hotel.data.checkIn }}</span>
                                                <span v-if="hotel.data.checkOut"> · Check-out: {{ hotel.data.checkOut }}</span>
                                            </div>
                                            <div class="package-missing-route" v-if="hotel.data && hotel.data.paxRooms && hotel.data.paxRooms.length">
                                                <span v-for="(room, roomIndex) in hotel.data.paxRooms" :key="'pax-' + roomIndex">
                                                    <span v-if="roomIndex > 0"> · </span>
                                                    {{ room.adults }} Adult<span v-if="Number(room.adults) !== 1">s</span><template v-if="Number(room.children) > 0">, {{ room.children }} Child<span v-if="Number(room.children) !== 1">ren</span></template>
                                                </span>
                                            </div>
                                            <div class="package-missing-message">{{ hotel.packageError }}</div>
                                            <el-button type="danger" size="small" @click="removehotel(hotel)">Remove</el-button>
                                        </div>
                                        <hotel-card-edit v-else :index="index" :hotel="hotel"   @removehotel="removehotel" :form="form" :staytypes="staytypes" :roomtypes="roomtypes" :mealplans="mealplans"></hotel-card-edit>
                                    </div>
                                </div>



                            </el-card>
                        </el-tab-pane>

                        <el-tab-pane v-if="form.includes.visa" label="Visa" name="visa">
<el-card class="mini-box-card  box-d-card mt-4" >
                                <template class="mini-card-header" #header>
                                    <span>Visa Details</span>

                                </template>
                                <el-row :gutter="20">
                                    <el-col :span="24" >
                                        <el-form-item label="Details" prop="visadetails" :rules="{
                                                            required: true,
                                                            message: 'Required',
                                                            trigger: ['blur','change'],
                                                          }">
                                            <el-input type="textarea" v-model="form.visadetails"  placeholder="Visa Details" />
                                        </el-form-item>

                                    </el-col>

                                </el-row>
                            </el-card>
                        </el-tab-pane>

                        <el-tab-pane v-if="form.includes.insurance" label="Insurance" name="insurance">
<el-card class="mini-box-card  box-d-card mt-4" >
                                <template class="mini-card-header" #header>
                                    <span>Travel Insurance Details</span>

                                </template>
                                <el-row :gutter="20">
                                    <el-col :span="24" >
                                        <el-form-item label="Details" prop="insurancedetails" :rules="{
                                                            required: true,
                                                            message: 'Required',
                                                            trigger: ['blur','change'],
                                                          }">
                                            <el-input type="textarea" v-model="form.insurancedetails"  placeholder="Travel Insurance Details" />
                                        </el-form-item>

                                    </el-col>

                                </el-row>
                            </el-card>
                        </el-tab-pane>

                        <el-tab-pane v-if="form.includes.landpackage" label="Day-wise" name="daywise">
<el-row>
                                <el-col :span="24" class="text-right mt-5">
                                    <el-text class="mr-3" size="small" type="info">Shrink a day, then drag its handle to change the order</el-text>
                                    <el-button size="large" type="primary" @click="autofillitenary()">Autofill Itenary</el-button>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24" v-for="(item,index) in form.itineraries" :key="dayRowKey(item, index)">
                                    <el-card
                                        class="mt-5 quote-day-card"
                                        :class="{
                                            'is-drag-over': dragState.type === 'days' && dragState.over === index && dragState.from !== index,
                                            'is-collapsed': isDayCollapsed(item)
                                        }"
                                        @dragover="onItemDragOver($event, 'days', index)"
                                        @drop="onDayDrop($event, index)"
                                    >
                                        <template #header>
                                            <div class="quote-day-header">
                                                <div
                                                    class="quote-drag-handle"
                                                    draggable="true"
                                                    title="Drag to rearrange this day"
                                                    @dragstart="onItemDragStart($event, 'days', index)"
                                                    @dragend="onItemDragEnd"
                                                >
                                                    <el-icon><Rank /></el-icon>
                                                </div>
                                                <el-button
                                                    class="quote-day-toggle"
                                                    :class="{ 'is-collapsed': isDayCollapsed(item) }"
                                                    circle
                                                    size="small"
                                                    :title="isDayCollapsed(item) ? 'Expand day' : 'Shrink day'"
                                                    @click="toggleDayCollapsed(item, index)"
                                                >
                                                    <el-icon><ArrowDown /></el-icon>
                                                </el-button>
                                                <el-form-item class="quote-day-title" :prop="'itineraries.' + index + '.title'" :rules="{
                                                            required: true,
                                                            message: 'Required',
                                                            trigger: ['blur','change'],
                                                          }">
                                                    <el-input v-model="item.title"  >
                                                        <template #prepend>DAY-{{item.day}}</template>
                                                    </el-input>
                                                </el-form-item>
                                                <el-button
                                                    class="quote-day-remove"
                                                    type="danger"
                                                    size="small"
                                                    :disabled="form.itineraries.length <= 1"
                                                    title="Remove this day"
                                                    @click="removeItineraryDay(index)"
                                                >
                                                    Remove
                                                </el-button>
                                            </div>
                                        </template>
                                        <div v-show="!isDayCollapsed(item)">
                                        <el-form-item 
                                            :prop="'itineraries.' + index + '.description'" 
                                            :rules="{
                                            validator: validateDescription,
                                                                trigger: ['blur', 'change'],
                                                            }"
                                            >
                                                <QuillEditor 
                                                    theme="snow" 
                                                    :content="item.description" 
                                                    contentType="html" 
                                                    style="width:100%;min-height:300px;" 
                                                    @update:content="(val) => { 
                                                        item.description = val; 
                                                        ruleFormRef.validateField('itineraries.' + index + '.description'); 
                                                    }"
                                                />
                                            </el-form-item>

                                        <div

                                        >
                                            <el-text tag="b" >Meals : </el-text>
                                            <el-checkbox  class="ml-4" v-model="item.breakfast" :value="true">
                                                Breakfast
                                            </el-checkbox>
                                            <el-checkbox v-model="item.lunch" :value="true">
                                                Lunch
                                            </el-checkbox>
                                            <el-checkbox v-model="item.dinner" :value="true">
                                                Dinner
                                            </el-checkbox>
                                            <el-checkbox v-model="item.lunchordinner" :value="true">
                                                Lunch or Dinner
                                            </el-checkbox>
                                        </div>

                                        <div class="mt-5" v-if="item.activities.length>0">
                                            <p>
                                                <el-text tag="b">Activities : </el-text>
                                                <el-text class="ml-2" size="small" type="info" v-if="item.activities.length > 1">Drag the handle to rearrange</el-text>
                                            </p>

                                            <div
                                                v-for="(activity, activityIndex) in item.activities"
                                                :key="activityListKey(activity, item.day, activityIndex)"
                                                class="quote-sortable-item"
                                                data-activity-row
                                                :data-activity-day="item.day"
                                                :data-activity-index="activityIndex"
                                                :class="{
                                                    'is-drag-over': String(activityDrag.day) === String(item.day) && activityDrag.over === activityIndex && activityDrag.from !== activityIndex,
                                                    'is-dragging': String(activityDrag.day) === String(item.day) && activityDrag.from === activityIndex
                                                }"
                                            >
                                                <div
                                                    class="quote-drag-handle"
                                                    title="Drag to rearrange"
                                                    @mousedown="onActivityHandleDown($event, item.day, activityIndex)"
                                                >
                                                    <el-icon><Rank /></el-icon>
                                                </div>
                                                <div class="quote-sortable-body">
                                                    <activity-card-edit :index="activityIndex" :activity="activity" :itninery="item" :form="form"></activity-card-edit>
                                                </div>
                                            </div>

                                        </div>
                                        <div class="mt-5" v-if="item.transfers.length>0">
                                            <p><el-text tag="b">Transfers : </el-text></p>
                                            <div v-for="(transfer,index) in item.transfers">
                                                <transfer-card-edit :key="transfer.id" :index="index"  :tranfer="transfer" :itninery="item"   :form="form"  ></transfer-card-edit>

                                            </div>
                                        </div>
                                        </div>
                                        <template #footer v-if="!isDayCollapsed(item)">
                                            <el-button type="primary" size="small" @click="addactivity(item)">Activities</el-button>
                                            <el-button class="ml-2" type="primary" size="small" @click="addtransfer(item)">Transfers</el-button>
                                        </template>
                                    </el-card>
                                </el-col>
                            </el-row>
                        </el-tab-pane>

                        <el-tab-pane v-if="form.includes.landpackage" label="Addons" name="addons">
<el-card class="mini-box-card  box-d-card mt-2" >
                                <template class="mini-card-header" #header>
                                    <span>Addons</span>

                                    <el-button size="small" @click="addaddonmodel=true">
                                        Add

                                    </el-button>

                                </template>

                                <div v-for="(addon,index) in form.addons" :key="addon.id">
                                    <div v-if="findAddonType(addon, addonTypes)" class="transport-addon-hint">
                                        <el-tag
                                            v-if="isBandedTypeAddon(addon, addonTypes)"
                                            size="small"
                                            type="info"
                                            class="mr-1"
                                        >
                                            {{ addon.pricing?.units || transportUnits(form.adults, capacityForAddon(addon)) }} unit(s)
                                            ({{ form.adults }} adults ÷ {{ capacityForAddon(addon) }})
                                        </el-tag>
                                        <el-tag
                                            v-if="isLandMarkupAddon(addon, addonTypes)"
                                            size="small"
                                            type="warning"
                                        >
                                            {{ findAddonType(addon, addonTypes).service_cost_percent }}% {{ findAddonType(addon, addonTypes).name }} service cost applies
                                        </el-tag>
                                        <el-tag
                                            v-else-if="isSeparateCascadeAddon(addon, addonTypes)"
                                            size="small"
                                            type="success"
                                        >
                                            Separate {{ findAddonType(addon, addonTypes).name }}:
                                            {{ findAddonType(addon, addonTypes).service_cost_percent }}% service cost
                                            + {{ findAddonType(addon, addonTypes).gst_percent }}% GST
                                        </el-tag>
                                    </div>
                                    <addon-card-edit
                                        :key="addon.id"
                                        :index="index"
                                        :addon="addon"
                                        :form="form"
                                        :addon-types="addonTypes"
                                        :pricing-rates="pricingRates"
                                        @removeaddon="updatelandcost"
                                        @updated="updatelandcost"
                                    ></addon-card-edit>



                                </div>



                            </el-card>
                        </el-tab-pane>

                        <el-tab-pane v-if="form.includes.landpackage || form.includes.hotel || form.includes.cruise || form.includes.visa || form.includes.insurance" label="Inclusions" name="inclusions">
<el-card class="mini-box-card  box-d-card mt-4" >
                                <template class="mini-card-header" #header>
                                    <span>Inclusions</span>

                                </template>

                                <el-row :gutter="20" >
                                    <el-col :span="24" >
                                        <el-form-item label="" prop="inclusions"  :rules="{
                                                            required: true,
                                                            message: 'Required',
                                                            trigger: ['blur','change'],
                                                          }">

                                            <el-select
                                                v-model="form.inclusions"
                                                filterable
                                                allow-create
                                                multiple
                                                style="width: 100%"
                                            >
                                                <el-option
                                                    v-for="item in inclusions"
                                                    :key="item"
                                                    :label="item"
                                                    :value="item"
                                                />
                                            </el-select>

                                        </el-form-item>
                                    </el-col>
                                </el-row>



                            </el-card>
<el-card class="mini-box-card  box-d-card mt-4" >
                                <template class="mini-card-header" #header>
                                    <span>Exclusions</span>

                                </template>

                                <el-row :gutter="20" >
                                    <el-col :span="24" >
                                        <el-form-item label="" prop="exclusions"  :rules="{
                                                            required: true,
                                                            message: 'Required',
                                                            trigger: ['blur','change'],
                                                          }">

                                            <el-select
                                                v-model="form.exclusions"
                                                filterable
                                                allow-create
                                                multiple
                                                style="width: 100%"
                                            >
                                                <el-option
                                                    v-for="item in exclusions"
                                                    :key="item"
                                                    :label="item"
                                                    :value="item"
                                                />
                                            </el-select>

                                        </el-form-item>
                                    </el-col>
                                </el-row>



                            </el-card>
                        </el-tab-pane>

                        <el-tab-pane label="Pricing" name="pricing">
<el-card class="mini-box-card  box-d-card mt-4" >
                                <template class="mini-card-header" #header>
                                    <span>Pricing Details</span>
                                </template>

                                <!-- Visa / Insurance rate entry (source inputs) -->
                                <el-row :gutter="20" class="mb-3" v-if="form.includes.visa || form.includes.insurance">
                                    <el-col :span="6" v-if="form.includes.visa">
                                        <p><el-text tag="b">Visa (per person)</el-text></p>
                                        <el-form-item :label="'Adult ('+form.adults+')'" prop="pricing.visa.adult">
                                            <el-input type="number" step="0.01" v-model="form.pricing.visa.adult" />
                                        </el-form-item>
                                        <el-form-item v-if="form.childs>0" :label="'Child ('+form.childs+')'" prop="pricing.visa.child">
                                            <el-input type="number" step="0.01" v-model="form.pricing.visa.child" />
                                        </el-form-item>
                                        <el-form-item v-if="form.infants>0" :label="'Infant ('+form.infants+')'" prop="pricing.visa.infant">
                                            <el-input type="number" step="0.01" v-model="form.pricing.visa.infant" />
                                        </el-form-item>
                                        <el-form-item label="Visa Total">
                                            <el-input type="number" step="0.01" v-model="form.pricing.visa.total" disabled/>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="6" v-if="form.includes.insurance">
                                        <p><el-text tag="b">Insurance (per person)</el-text></p>
                                        <el-form-item :label="'Adult ('+form.adults+')'" prop="pricing.insurance.adult">
                                            <el-input type="number" step="0.01" v-model="form.pricing.insurance.adult" />
                                        </el-form-item>
                                        <el-form-item v-if="form.childs>0" :label="'Child ('+form.childs+')'" prop="pricing.insurance.child">
                                            <el-input type="number" step="0.01" v-model="form.pricing.insurance.child" />
                                        </el-form-item>
                                        <el-form-item v-if="form.infants>0" :label="'Infant ('+form.infants+')'" prop="pricing.insurance.infant">
                                            <el-input type="number" step="0.01" v-model="form.pricing.insurance.infant" />
                                        </el-form-item>
                                        <el-form-item label="Insurance Total">
                                            <el-input type="number" step="0.01" v-model="form.pricing.insurance.total" disabled/>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <!-- Land cascade breakdown -->
                                <div v-if="form.includes.landpackage || form.includes.hotel || form.includes.cruise || form.includes.visa || form.includes.insurance" class="land-cascade">
                                    <p class="land-cascade-title"><el-text tag="b" size="large">Land Package Cascade</el-text></p>
                                    <table class="land-cascade-table">
                                        <tbody>
                                            <tr v-if="form.pricing.landcascade.hotel_cost > 0 || form.includes.hotel">
                                                <td>Hotel (Stays)</td>
                                                <td class="amt">{{ formatMoney(form.pricing.landcascade.hotel_cost) }}</td>
                                            </tr>
                                            <tr v-if="form.pricing.landcascade.hotel_cost > 0 || form.includes.hotel">
                                                <td>Hotel Service Cost ({{ pricingRates.hotel_service_charge }}%)</td>
                                                <td class="amt">{{ formatMoney(form.pricing.landcascade.hotel_profit) }}</td>
                                            </tr>
                                            <tr v-if="form.pricing.landcascade.hotel_cost > 0 || form.includes.hotel" class="sub">
                                                <td>Sub Hotel Cost</td>
                                                <td class="amt">{{ formatMoney(form.pricing.landcascade.hotel_subtotal) }}</td>
                                            </tr>

                                            <template v-for="line in (form.pricing.landcascade.markup_addons || [])" :key="'markup-'+line.code">
                                                <tr v-if="line.cost > 0">
                                                    <td>{{ line.name }}</td>
                                                    <td class="amt">{{ formatMoney(line.cost) }}</td>
                                                </tr>
                                                <tr v-if="line.cost > 0">
                                                    <td>{{ line.name }} Service Cost ({{ line.percent }}%)</td>
                                                    <td class="amt">{{ formatMoney(line.profit) }}</td>
                                                </tr>
                                                <tr v-if="line.cost > 0" class="sub">
                                                    <td>Sub {{ line.name }} Total</td>
                                                    <td class="amt">{{ formatMoney(line.subtotal) }}</td>
                                                </tr>
                                            </template>

                                            <tr v-if="form.pricing.landcascade.other_addons_cost > 0">
                                                <td>Other Addons</td>
                                                <td class="amt">{{ formatMoney(form.pricing.landcascade.other_addons_cost) }}</td>
                                            </tr>
                                            <tr v-if="form.pricing.landcascade.activities_cost > 0">
                                                <td>Activities &amp; Transfers</td>
                                                <td class="amt">{{ formatMoney(form.pricing.landcascade.activities_cost) }}</td>
                                            </tr>
                                            <tr v-if="form.pricing.landcascade.cruise_cost > 0 || form.includes.cruise">
                                                <td>Cruise</td>
                                                <td class="amt">{{ formatMoney(form.pricing.landcascade.cruise_cost) }}</td>
                                            </tr>
                                            <tr v-if="form.pricing.landcascade.visa_cost > 0 || form.includes.visa">
                                                <td>Visa</td>
                                                <td class="amt">{{ formatMoney(form.pricing.landcascade.visa_cost) }}</td>
                                            </tr>
                                            <tr v-if="form.pricing.landcascade.insurance_cost > 0 || form.includes.insurance">
                                                <td>Insurance</td>
                                                <td class="amt">{{ formatMoney(form.pricing.landcascade.insurance_cost) }}</td>
                                            </tr>

                                            <tr class="total-row">
                                                <td>Land Subtotal</td>
                                                <td class="amt">{{ formatMoney(form.pricing.landcascade.land_subtotal) }}</td>
                                            </tr>
                                            <tr>
                                                <td>Backup Cost ({{ pricingRates.backup_cost }}%)</td>
                                                <td class="amt">{{ formatMoney(form.pricing.landcascade.backup_cost) }}</td>
                                            </tr>
                                            <tr class="sub">
                                                <td>Total after Backup</td>
                                                <td class="amt">{{ formatMoney(form.pricing.landcascade.after_backup) }}</td>
                                            </tr>
                                            <tr>
                                                <td>Overall Service Cost ({{ pricingRates.overall_service_charge }}%)</td>
                                                <td class="amt">{{ formatMoney(form.pricing.landcascade.service_cost) }}</td>
                                            </tr>
                                            <tr class="sub">
                                                <td>Total after Overall Service Cost</td>
                                                <td class="amt">{{ formatMoney(form.pricing.landcascade.after_service) }}</td>
                                            </tr>
                                            <tr>
                                                <td>Profit ({{ pricingRates.land_profit }}%)</td>
                                                <td class="amt">{{ formatMoney(form.pricing.landcascade.land_profit) }}</td>
                                            </tr>
                                            <tr class="sub">
                                                <td>Land Cost (Before GST)</td>
                                                <td class="amt">{{ formatMoney(form.pricing.landcascade.land_before_gst) }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <!-- Separate cascade addons (Helicopter-style) -->
                                <div
                                    v-for="line in (form.pricing.separate_cascades || []).filter(l => l.cost > 0)"
                                    :key="'sep-'+line.code"
                                    class="land-cascade mt-4"
                                >
                                    <p class="land-cascade-title"><el-text tag="b" size="large">{{ line.name }}</el-text></p>
                                    <table class="land-cascade-table">
                                        <tbody>
                                            <tr>
                                                <td>{{ line.name }} Cost</td>
                                                <td class="amt">{{ formatMoney(line.cost) }}</td>
                                            </tr>
                                            <tr>
                                                <td>{{ line.name }} Service Cost ({{ line.service_cost_percent }}%)</td>
                                                <td class="amt">{{ formatMoney(line.profit) }}</td>
                                            </tr>
                                            <tr class="sub">
                                                <td>Subtotal (Before GST)</td>
                                                <td class="amt">{{ formatMoney(line.before_gst) }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <!-- Flight cascade (same look as land / helicopter) -->
                                <div v-if="form.includes.flight" class="land-cascade mt-4">
                                    <p class="land-cascade-title"><el-text tag="b" size="large">Flight</el-text></p>
                                    <table class="land-cascade-table">
                                        <tbody>
                                            <tr>
                                                <td>Flight Cost</td>
                                                <td class="amt">{{ formatMoney(form.pricing.flight.total) }}</td>
                                            </tr>
                                            <tr>
                                                <td>Flight Service Cost ({{ pricingRates.flight_service_charge }}%)</td>
                                                <td class="amt">{{ formatMoney(form.pricing.flightprofit.total) }}</td>
                                            </tr>
                                            <tr class="sub">
                                                <td>Subtotal (Before GST)</td>
                                                <td class="amt">{{ formatMoney(roundMoney(form.pricing.flight.total) + roundMoney(form.pricing.flightprofit.total)) }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <p class="mt-2" style="color:#909399;font-size:12px;">
                                        Per adult {{ formatMoney(form.pricing.flight.adult) }}
                                        <span v-if="form.childs>0"> · Per child {{ formatMoney(form.pricing.flight.child) }}</span>
                                        <span v-if="form.infants>0"> · Per infant {{ formatMoney(form.pricing.flight.infant) }}</span>
                                    </p>
                                </div>
                            </el-card>
<el-card class="mini-box-card  box-d-card mt-4" >
                                <template class="mini-card-header" #header>
                                    <span>Pricing Summary</span>
                                </template>

                                <table class="land-cascade-table">
                                    <tbody>
                                        <tr class="total-row">
                                            <td colspan="2">Land package</td>
                                        </tr>
                                        <tr>
                                            <td>Land before GST</td>
                                            <td class="amt">{{ formatMoney(chargedTaxes.land_before_gst) }}</td>
                                        </tr>
                                        <tr>
                                            <td colspan="2">
                                                <el-form-item label="Land discount type" class="mb-2">
                                                    <el-select style="width:100%" v-model="form.discount_type" @change="validateDiscountField">
                                                        <el-option label="Percent (%)" value="percent"></el-option>
                                                        <el-option label="Amount (₹)" value="amount"></el-option>
                                                    </el-select>
                                                </el-form-item>
                                                <el-form-item
                                                    :label="form.discount_type === 'percent' ? 'Discount (%) of land before GST' : 'Discount off the customer total (₹)'"
                                                    prop="discount_value"
                                                    class="mb-0"
                                                >
                                                    <el-input
                                                        type="number"
                                                        min="0"
                                                        step="0.01"
                                                        v-model="form.discount_value"
                                                        @input="validateDiscountField"
                                                        :placeholder="form.discount_type === 'percent' ? 'Percent of land before GST' : 'Rupees off the customer total'"
                                                    />
                                                </el-form-item>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>{{ form.discount_type === 'amount' ? 'Discount off customer total' : 'Land discount' }}</td>
                                            <td class="amt">{{ formatMoney(chargedTaxes.discount_amount) }}</td>
                                        </tr>
                                        <tr>
                                            <td>Removed before GST</td>
                                            <td class="amt">{{ formatMoney(chargedTaxes.pre_tax_discount) }}</td>
                                        </tr>
                                        <tr>
                                            <td>Land after discount</td>
                                            <td class="amt">{{ formatMoney(chargedTaxes.land_after_discount) }}</td>
                                        </tr>
                                        <tr>
                                            <td>Land GST ({{ chargedTaxes.land_gst_percent }}% of land after discount)</td>
                                            <td class="amt">{{ formatMoney(chargedTaxes.land_gst) }}</td>
                                        </tr>
                                        <tr v-if="chargedTaxes.tcs_included">
                                            <td>TCS ({{ chargedTaxes.tcs_percent }}% of land after discount + land GST)</td>
                                            <td class="amt">{{ formatMoney(chargedTaxes.tcs) }}</td>
                                        </tr>
                                        <tr class="sub">
                                            <td>Land total</td>
                                            <td class="amt">{{ formatMoney(chargedTaxes.land_total) }}</td>
                                        </tr>

                                        <tr v-if="form.includes.flight" class="total-row">
                                            <td colspan="2">Flight (not discounted)</td>
                                        </tr>
                                        <tr v-if="form.includes.flight">
                                            <td>Flight fare</td>
                                            <td class="amt">{{ formatMoney(chargedTaxes.flight_fare) }}</td>
                                        </tr>
                                        <tr v-if="form.includes.flight">
                                            <td>Flight service</td>
                                            <td class="amt">{{ formatMoney(chargedTaxes.flight_service) }}</td>
                                        </tr>
                                        <tr v-if="form.includes.flight">
                                            <td>Flight GST ({{ chargedTaxes.flight_gst_percent }}% of full service)</td>
                                            <td class="amt">{{ formatMoney(chargedTaxes.flight_gst) }}</td>
                                        </tr>
                                        <tr v-if="form.includes.flight" class="sub">
                                            <td>Flight total</td>
                                            <td class="amt">{{ formatMoney(chargedTaxes.flight_total) }}</td>
                                        </tr>

                                        <template v-for="line in chargedTaxes.separate_lines.filter(l => l.before_gst > 0 || l.gst > 0)" :key="'calc-sep-'+line.code">
                                            <tr class="total-row">
                                                <td colspan="2">{{ line.name }} (not discounted)</td>
                                            </tr>
                                            <tr>
                                                <td>{{ line.name }} before GST</td>
                                                <td class="amt">{{ formatMoney(line.before_gst) }}</td>
                                            </tr>
                                            <tr>
                                                <td>{{ line.name }} GST ({{ line.gst_percent }}%)</td>
                                                <td class="amt">{{ formatMoney(line.gst) }}</td>
                                            </tr>
                                            <tr class="sub">
                                                <td>{{ line.name }} total</td>
                                                <td class="amt">{{ formatMoney(line.total) }}</td>
                                            </tr>
                                        </template>

                                        <tr class="grand-row">
                                            <td>Customer total</td>
                                            <td class="amt">{{ formatMoney(chargedTaxes.customer_total) }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <p class="mt-2" style="color:#909399;font-size:12px;">
                                    <template v-if="taxesAbsorbed">GST and TCS are calculated and stored, and are not added to the customer total. The land discount does not change the flight.</template>
                                    <template v-else>Land GST and TCS are calculated after the land discount and added to the total. Flight GST is calculated on the full flight service.</template>
                                </p>

                            </el-card>
                        </el-tab-pane>
                            </el-tabs>
                        </el-col>
                    </el-row>

                </el-form>
            </el-col>

        </el-row>
    </el-main>


    <SearchFlight v-if="searchflightsmodel"  @canceli="searchflightsmodel=false" :form="form" @addflight="addflight" @addflights="addflights"></SearchFlight>
    <MannualFlight v-if="addmanualflightsmodel"  @canceli="addmanualflightsmodel=false" :form="form" @addflight="addflightMannual" ></MannualFlight>

    <SearchHotel v-if="searchhotelmodel"  @canceli="searchhotelmodel=false" :form="form" @addhotel="addhotel" ></SearchHotel>

    <MannualHotelAdd v-if="addmanualhotelmodel"  @canceli="addmanualhotelmodel=false" :form="form" @addhotel="addhotelm" :staytypes="staytypes" :roomtypes="roomtypes" :mealplans="mealplans"></MannualHotelAdd>

    <AddDayActivity v-if="addactivitymodal" :itineries="addactiten" :destinations="form.cities" :form="form" @canceli="addactivitymodal=false" @added="addactivitymodal=false"></AddDayActivity>

    <AddDayTransfer v-if="addtransfermodal" :itineries="addtranfern"  :form="form" @canceli="addtransfermodal=false" @added="addtransfermodal=false"></AddDayTransfer>
    <AddAddon
        v-if="addaddonmodel"
        :form="form"
        :addon-types="addonTypes"
        :pricing-rates="pricingRates"
        @canceli="addaddonmodel=false"
        @added="() => { addaddonmodel=false; updatelandcost(); }"
    ></AddAddon>

</template>
<style scoped>
.quote-sortable-item {
    display: flex;
    align-items: stretch;
    gap: 8px;
    margin-bottom: 10px;
    border: 1px dashed transparent;
    border-radius: 8px;
    padding: 2px;
}
.quote-sortable-item.is-drag-over {
    border-color: #409eff;
    background: #ecf5ff;
}
.quote-sortable-item.is-dragging {
    opacity: 0.55;
}
.quote-drag-handle {
    flex: 0 0 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: grab;
    color: #909399;
    border-radius: 6px;
    background: #f4f4f5;
    user-select: none;
    position: relative;
    z-index: 2;
}
.quote-drag-handle :deep(.el-icon) {
    pointer-events: none;
}
.quote-drag-handle:active {
    cursor: grabbing;
}
.quote-sortable-body {
    flex: 1;
    min-width: 0;
}
.package-missing-card {
    border: 1px solid #f3d19e;
    background: #fdf6ec;
    border-radius: 8px;
    padding: 12px 14px;
}
.package-missing-title {
    color: #b88230;
    font-weight: 600;
    margin-bottom: 4px;
}
.package-missing-route {
    color: #606266;
    margin-bottom: 4px;
}
.package-missing-message {
    color: #303133;
    margin-bottom: 10px;
}
.quote-day-header {
    display: flex;
    align-items: center;
    gap: 8px;
}
.quote-day-title {
    flex: 1;
    margin-bottom: 0;
}
.quote-day-remove {
    flex: 0 0 auto;
    min-width: 72px;
    color: #fff !important;
    background-color: #f56c6c !important;
    border-color: #f56c6c !important;
}
.quote-day-remove :deep(span) {
    color: #fff !important;
}
.quote-day-toggle :deep(.el-icon) {
    transition: transform 0.15s ease;
}
.quote-day-toggle.is-collapsed :deep(.el-icon) {
    transform: rotate(-90deg);
}
.quote-day-card.is-drag-over {
    outline: 2px solid #409eff;
    outline-offset: 2px;
}
.quote-day-card.is-collapsed :deep(.el-card__body) {
    display: none;
}
.land-cascade-title {
    margin-bottom: 10px;
}
.land-cascade-table {
    width: 100%;
    max-width: 640px;
    border-collapse: collapse;
}
.land-cascade-table td {
    padding: 6px 10px;
    border-bottom: 1px solid #ebeef5;
    font-size: 13px;
}
.land-cascade-table td.amt {
    text-align: right;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
}
.land-cascade-table tr.sub td {
    color: #606266;
    font-weight: 600;
}
.land-cascade-table tr.total-row td {
    font-weight: 700;
    background: #f5f7fa;
}
.land-cascade-table tr.grand-row td {
    font-weight: 700;
    font-size: 15px;
    background: #ecf5ff;
    border-bottom: none;
}
.transport-addon-hint {
    margin-bottom: 4px;
}
.land-cascade-summary p {
    margin: 2px 0;
}
.quote-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 10px;
    position: sticky;
    top: 0;
    z-index: 30;
    padding: 10px 12px;
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}
.quote-toolbar-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
}
.quote-section-tabs {
    background: #fff;
}
.quote-section-tabs :deep(.el-tabs__header) {
    position: sticky;
    top: 58px;
    z-index: 20;
    background: #fff;
    margin: 0;
}
.quote-section-tabs :deep(.el-tabs__item) {
    font-weight: 600;
}
.quote-section-tabs :deep(.el-tabs__content) {
    padding-top: 12px;
}
</style>
<style>
body.quote-activity-dragging {
    cursor: grabbing;
    user-select: none;
}
</style>
